import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as adminActions from '../../redux/actions/admin-actions';
import * as b2cActions from '../../redux/actions/b2c-actions';
import * as productActions from '../../redux/actions/product-actions';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  MED_BENEFITS,
  COMPLETE_ONLY_BENEFITS,
  COMPARE_ROWS,
  CheckIcon,
  HelpIcon,
  ShieldIcon,
  MedicalPlanIcon,
  WarningIcon,
  CompletePlanIcon,
  UpArrowIcon,
  CloseIcon,
  HomeIcon,
  LockIcon,
  SidebarPlanIcon,
  SpinnerIcon
} from './data';
import AddressAutocomplete from './AddressAutocomplete';
import logo from '../../images/CAP-Logo-White.png';
import {
  todayStr,
  ageFromDob,
  fmtDate,
  money0,
  money,
  isValidEmail,
  inclusiveDaysBetween,
  validatePhoneForCountry
} from './helpers';

import { Req, Lbl, ErrText, SectionLabel, Field, Highlight, BackBtn, SumRow, Pin, Check } from './components';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import StripePaymentForm from './StripePaymentForm';
import QuoteConfirmation from './QuoteConfirmation';
import config from '../../../../config';
import { initKlaviyo, trackViewedProduct, trackAddedToCart, trackCheckoutStarted } from '../../services/klaviyo';
import { initFacebookPixel, trackFacebookAddToCart, trackFacebookPurchase } from '../../services/facebookPixel';

const stripePromise = loadStripe(config.stripeKey);

// Initialize Klaviyo onsite script (safe to call multiple times — no-op after first)
initKlaviyo();

function Quote(props) {
  // --- States ---
  const [step, setStep] = useState(() => {
    if (typeof window !== 'undefined') {
      const qs = new URLSearchParams(window.location.search);
      if (qs.get('redirect_status')) return 3;
    }
    return 1;
  });
  const [residency, setResidency] = useState('');
  const [resQuery, setResQuery] = useState('');
  const [resActive, setResActive] = useState(0);
  const [resDropdownOpen, setResDropdownOpen] = useState(false);
  const resRef = useRef(null);
  const progressRef = useRef(null);
  const [residenceStates, setResidenceStates] = useState([]);
  const [stateQuery, setStateQuery] = useState('');
  const [stateActive, setStateActive] = useState(0);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const stateRef = useRef(null);
  const [destinations, setDestinations] = useState([]);
  const [destQuery, setDestQuery] = useState('');
  const [destActive, setDestActive] = useState(0);
  const [destDropdownOpen, setDestDropdownOpen] = useState(false);
  const [departure, setDeparture] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [annual, setAnnual] = useState(false);
  const [coverageType, setCoverageType] = useState('individual');
  const [familyCount, setFamilyCount] = useState(0);
  const [plan, setPlan] = useState('complete');
  const [domesticAddon, setDomesticAddon] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [mobileCompareTab, setMobileCompareTab] = useState('medical');
  const [email, setEmail] = useState('');
  const [payMethod, setPayMethod] = useState('card');
  const [promoInput, setPromoInput] = useState('');
  const [promoApplied, setPromoApplied] = useState(null);
  const [appliedCouponCode, setAppliedCouponCode] = useState('');
  const [promoError, setPromoError] = useState(false);
  const [orderSummaryPricing, setOrderSummaryPricing] = useState(null);
  const [cardPricing, setCardPricing] = useState(null);
  const [pricingLoading, setPricingLoading] = useState(false);
  const [cardPricingLoading, setCardPricingLoading] = useState(false);
  const [phones, setPhones] = useState({
    primary: { countryCode: 'US', dialCode: '1', value: '' }
  });
  const [familyNames, setFamilyNames] = useState({});
  const [familyEmails, setFamilyEmails] = useState({});
  const [familyEmailExists, setFamilyEmailExists] = useState({});
  const [familyDobs, setFamilyDobs] = useState({});
  const [familyAddr, setFamilyAddr] = useState({});
  const [familyMinor, setFamilyMinor] = useState({});
  const [familyUserIds, setFamilyUserIds] = useState({});
  const [familyPendingInfo, setFamilyPendingInfo] = useState({});
  const [familyNameLocked, setFamilyNameLocked] = useState({});
  const [showFamilyAccountNotice, setShowFamilyAccountNotice] = useState(null);
  const [fullName, setFullName] = useState('');
  const [dob, setDob] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [parental, setParental] = useState(false);
  const [touched, setTouched] = useState({});
  const [emailChecking, setEmailChecking] = useState(false);
  const [primaryEmailExists, setPrimaryEmailExists] = useState(false);
  const [availableMembers, setAvailableMembers] = useState([]);
  const [showExistingAccountNotice, setShowExistingAccountNotice] = useState(false);
  const [pendingAccountName, setPendingAccountName] = useState('');
  const [primaryNameLocked, setPrimaryNameLocked] = useState(false);
  const [isApplyingPromo, setIsApplyingPromo] = useState(false);
  const [utmSource, setUtmSource] = useState('');
  const [utmMedium, setUtmMedium] = useState('');
  const [utmCampaign, setUtmCampaign] = useState('');
  // Payment processing state
  const [payProcessing, setPayProcessing] = useState(() => {
    if (typeof window !== 'undefined') {
      const qs = new URLSearchParams(window.location.search);
      if (qs.get('redirect_status') === 'succeeded') return true;
    }
    return false;
  });
  const [payError, setPayError] = useState('');
  // Stripe PaymentIntent state
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState(null);

  const [mobileSummaryOpen, setMobileSummaryOpen] = useState(false);

  // Klaviyo tracking refs — prevent duplicate event fires on re-renders
  const klaviyoViewedProductFired = useRef(false);

  const scrollQuoteToTop = useCallback(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const root = document.querySelector('.cap-root');
    if (root) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const docEl = document.documentElement;
    const body = document.body;
    if (docEl) docEl.scrollTop = 0;
    if (body) body.scrollTop = 0;
  }, []);

  const goToStep = useCallback(
    (nextStep) => {
      setStep(nextStep);

      if (typeof window !== 'undefined') {
        window.setTimeout(() => {
          scrollQuoteToTop();
          if (progressRef.current) {
            progressRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 120);
      }
    },
    [scrollQuoteToTop]
  );
  
  

  const [countriesData, setCountriesData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [staticProducts, setStaticProducts] = useState([]);

  // Raw inbound quote param (the base64 blob the marketing site appends to
  // the /quote URL to carry trip details over) — captured as-is on load so
  // it can be passed straight through to tracking events, unmodified.
  
  const [quoteParamValue, setQuoteParamValue] = useState(null);

  const isOrderResponseSuccessful = useCallback(function(orderRes) {
    if (!orderRes) return false;
    if (orderRes.error === true || orderRes.error === 'true' || orderRes.IsSuccess === false) return false;

    const statusCode = Number(orderRes.status || orderRes.statusCode);
    if (!Number.isNaN(statusCode) && statusCode >= 400) return false;

    const responseStatus = orderRes.response && Number(orderRes.response.status);
    if (!Number.isNaN(responseStatus) && responseStatus >= 400) return false;

    return true;
  }, []);

  const destRef = useRef(null);
  const pricingRequestRef = useRef(0);

  // --- Load Dynamic Countries and States ---
  useEffect(() => {
    const loadData = async () => {
      let loadedCountries = [];
      if (props.getCountryListDetail) {
        const data = await props.getCountryListDetail();
        if (data && data.length > 0) {
          setCountriesData(data);
          loadedCountries = data;
        }
      }

      // fetching states from getCompleteProductInfoDetail
      if (props.getCompleteProductInfoDetail) {
        const data = await props.getCompleteProductInfoDetail();
        if (data && data.length > 0) {
          setStatesData(data);
        }
      }

      if (props.getProducts) {
        props
          .getProducts({
            filters: { productCode: 'CAP_B2C' },
            pagination: { page: 1, pageSize: 20 }
          })
          .then((res) => {
            if (res && res.data) {
              setStaticProducts(res.data);
            }
          });
      }

      // --- Parse URL query params ---
      try {
        const searchStr = (props.location && props.location.search) || window.location.search;
        if (searchStr && searchStr.length > 1) {
          let isEncoded = false;
          try {
            // First try to parse as base64 encoded string
            const decoded = atob(searchStr.substring(1));
            // Basic validation to see if it looks like our query string
            if (decoded && decoded.includes('=')) {
              isEncoded = true;
              // Keep the raw, un-decoded value exactly as received — this is
              // what tracking events pass through (see quoteParamValue).
              setQuoteParamValue(searchStr.substring(1));
              const params = {};
              decoded.split('&').forEach(function(part) {
                const kv = part.split('=');
                if (kv.length === 2) params[kv[0]] = decodeURIComponent(kv[1]);
              });

              // Departure & Return dates
              if (params.start_date) setDeparture(params.start_date);
              if (params.end_date) setReturnDate(params.end_date);

              // Annual toggle - check explicit param or if duration is 365+ days
              if (params.isAnnual === 'true' || params.isAnnual === '1') {
                setAnnual(true);
              } else if (params.start_date && params.end_date) {
                const start = new Date(params.start_date);
                const end = new Date(params.end_date);

                // Inclusive difference (includes both start and end dates)
                const daysDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

                if (daysDiff >= 365) {
                  setAnnual(true);
                }
              }
              // Destinations - map country codes to country ids
              if (params.countries) {
                const codes = params.countries.split(',').map(function(c) {
                  return c.trim();
                });
                const countrySource = loadedCountries.length > 0 ? loadedCountries : [];
                const matchedIds = [];
                codes.forEach(function(code) {
                  const found = countrySource.find(function(c) {
                    return (c.countryCode || '').toUpperCase() === code.toUpperCase();
                  });
                  if (found) matchedIds.push(String(found.countryId));
                });
                if (matchedIds.length > 0) setDestinations(matchedIds);
              }

              // Residency country
              if (params.residence_country) {
                const foundByName = loadedCountries.find(function(c) {
                  return c.countryName === params.residence_country;
                });
                if (foundByName) setResidency(String(foundByName.countryId));
              } else if (params.resi_c_code && loadedCountries.length > 0) {
                const found = loadedCountries.find(function(c) {
                  return (c.countryCode || '').toUpperCase() === params.resi_c_code.toUpperCase();
                });
                if (found) setResidency(String(found.countryId));
              }

              // Residence states (US domestic) by state ids
              if (params.res_state_lists) {
                const statesSource = props.allUsStates || [];
                const stateIds = params.res_state_lists
                  .split(',')
                  .map(function(s) {
                    return s.trim();
                  })
                  .map(function(stateValue) {
                    const foundState = statesSource.find(function(st) {
                      return (
                        String(st.stateId) === stateValue ||
                        (st.stateCode || '').toUpperCase() === stateValue.toUpperCase() ||
                        st.stateName === stateValue
                      );
                    });
                    return foundState ? String(foundState.stateId) : null;
                  })
                  .filter(Boolean);
                if (stateIds.length > 0) setResidenceStates(stateIds);
              }

              // Traveller count / coverage type
              if (params.traveller_count) {
                const count = parseInt(params.traveller_count, 10);
                if (count > 1) {
                  setCoverageType('family');
                  setFamilyCount(count - 1);
                }
              }

              if (params.utm_source) setUtmSource(String(params.utm_source));
              if (params.utm_medium) setUtmMedium(String(params.utm_medium));
              if (params.utm_campaign) setUtmCampaign(String(params.utm_campaign));
            }
          } catch (err) {
            // Not a valid base64 string
          }

          if (!isEncoded) {
            const urlParams = new URLSearchParams(searchStr);
            if (urlParams.has('plan')) {
              const planParam = urlParams.get('plan');
              if (['complete', 'medical', 'domestic'].includes(planParam)) {
                setPlan(planParam);
              }
            }

            // UTM params
            const utmSourceParam = urlParams.get('utm_source');
            const utmMediumParam = urlParams.get('utm_medium');
            const utmCampaignParam = urlParams.get('utm_campaign');
            if (utmSourceParam) setUtmSource(utmSourceParam);
            if (utmMediumParam) setUtmMedium(utmMediumParam);
            if (utmCampaignParam) setUtmCampaign(utmCampaignParam);

            // isAnnual toggle
            const isAnnualParam = urlParams.get('isAnnual');
            if (isAnnualParam === 'true' || isAnnualParam === '1') {
              setAnnual(true);
            }

            // countries — map country codes to country ids
            if (urlParams.has('countries')) {
              const codes = urlParams
                .get('countries')
                .split(',')
                .map(function(c) {
                  return c.trim();
                });
              const countrySource = loadedCountries.length > 0 ? loadedCountries : [];
              const matchedIds = [];
              codes.forEach(function(code) {
                const found = countrySource.find(function(c) {
                  return (c.countryCode || '').toUpperCase() === code.toUpperCase();
                });
                if (found) matchedIds.push(String(found.countryId));
              });
              if (matchedIds.length > 0) setDestinations(matchedIds);
            }
          }
        }
      } catch (e) {
        // Invalid or missing query string - form stays empty
        console.warn('Could not parse URL params:', e);
      }
    };
    loadData();
  }, []);

  // Click outside destination/state dropdowns to close
  useEffect(() => {
    function handleClickOutside(event) {
      if (resRef.current && !resRef.current.contains(event.target)) {
        setResDropdownOpen(false);
      }
      if (destRef.current && !destRef.current.contains(event.target)) {
        setDestDropdownOpen(false);
      }
      if (stateRef.current && !stateRef.current.contains(event.target)) {
        setStateDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Hide trust badges on scroll (mobile)
  useEffect(() => {
    const handleScroll = () => {
      if (!progressRef.current) return;
      if (window.scrollY > 120) {
        progressRef.current.classList.add('cap-progress--scrolled');
      } else if (window.scrollY < 20) {
        progressRef.current.classList.remove('cap-progress--scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    // Check initial state
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // --- Mapped Data list ---
  const countryListMemo = useMemo(() => {
    if (countriesData && countriesData.length > 0) {
      return countriesData.map((c) => ({
        countryId: String(c.countryId),
        countryCode: c.countryCode,
        countryName: c.countryName
      }));
    }
    return [];
  }, [countriesData]);

  const stateList = useMemo(() => {
    if (statesData && statesData.length > 0) {
      return statesData;
    }
    return [];
  }, [statesData]);

  const countryById = useMemo(() => {
    const map = {};
    countryListMemo.forEach((country) => {
      map[String(country.countryId)] = country;
    });
    return map;
  }, [countryListMemo]);

  const stateById = useMemo(() => {
    const map = {};
    stateList.forEach((stateObj) => {
      map[String(stateObj.stateId)] = stateObj;
    });
    return map;
  }, [stateList]);

  const residencyCountry = residency ? countryById[String(residency)] : null;
  const residencyCode = residencyCountry ? residencyCountry.countryCode : '';
  const selectedDestinations = useMemo(() => {
    return destinations.map((id) => countryById[String(id)]).filter(Boolean);
  }, [destinations, countryById]);
  const selectedStateRecords = useMemo(() => {
    return residenceStates.map((id) => stateById[String(id)]).filter(Boolean);
  }, [residenceStates, stateById]);
  const selectedStateNames = selectedStateRecords.map((stateObj) => stateObj.stateName);
  const residencyIsUS = ['US', 'MP', 'PR', 'AS', 'GU', 'VI'].includes(residencyCode);
  const destinationsIncludeUS = selectedDestinations.some((country) => country.countryCode === 'US');

  // --- Derived Values ---
  const daysCount = useMemo(() => {
    if (annual) return 365;
    if (!departure || !returnDate) return 0;
    const dayDiff = Math.round((new Date(returnDate).getTime() - new Date(departure).getTime()) / 86400000 + 1);
    return dayDiff > 0 ? dayDiff : 0;
  }, [annual, departure, returnDate]);

  const travelers = useMemo(() => {
    return coverageType === 'family' ? 1 + Math.max(1, familyCount) : 1;
  }, [coverageType, familyCount]);

  const domesticEligible = useMemo(() => {
    return residencyIsUS && destinationsIncludeUS;
  }, [residencyIsUS, destinationsIncludeUS]);

  const domesticOnly = useMemo(() => {
    return false; // Disabled: we now redirect to medical and complete plans for all.
  }, [residencyIsUS, destinations, selectedDestinations]);

  useEffect(() => {
    if (!domesticEligible || domesticOnly) {
      setDomesticAddon(false);
    }
  }, [domesticEligible, domesticOnly]);

  const displayReturnDate = useMemo(() => {
    if (annual) {
      const d = new Date(todayStr() + 'T00:00:00');
      d.setDate(d.getDate() + 364);
      return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }
    return returnDate;
  }, [annual, returnDate]);

  // --- Autocomplete Matches ---
  const resMatches = useMemo(() => {
    const query = resQuery.trim().toLowerCase();
    return countryListMemo.filter((c) => {
      if (!query) return true;
      return c.countryName.toLowerCase().includes(query) || (c.countryCode || '').toLowerCase().includes(query);
    });
  }, [resQuery, countryListMemo]);

  const resActiveIndex = Math.max(0, Math.min(resActive, resMatches.length - 1));

  const handleSelectResidency = useCallback(
    (countryId) => {
      setResidency(String(countryId));
      setResQuery('');
      setResDropdownOpen(false);

      // Reset states if not US
      if (countryById && countryById[countryId]) {
        if (countryById[countryId].countryCode !== 'US') {
          setResidenceStates([]);
        }
      }
    },
    [countryById]
  );

  const matches = useMemo(() => {
    const query = destQuery.trim().toLowerCase();
    return countryListMemo.filter((countryObj) => {
      const isSelected = destinations.includes(String(countryObj.countryId));
      if (isSelected) return false;
      if (!query) return true; // Show all available countries when query is empty on focus
      return countryObj.countryName.toLowerCase().includes(query);
    });
  }, [destQuery, destinations, countryListMemo]);

  const active = Math.max(0, Math.min(destActive, matches.length - 1));

  const stateMatches = useMemo(() => {
    const query = stateQuery.trim().toLowerCase();
    return stateList.filter((st) => {
      const isSelected = residenceStates.includes(String(st.stateId));
      if (isSelected) return false;
      if (!query) return true;
      return st.stateName.toLowerCase().includes(query);
    });
  }, [stateQuery, residenceStates, stateList]);

  const stateActiveIndex = Math.max(0, Math.min(stateActive, stateMatches.length - 1));

  // --- Handlers ---
  const addDest = useCallback(
    (countryId) => {
      const idStr = String(countryId);
      if (!destinations.includes(idStr)) {
        setDestinations((prev) => [...prev, idStr]);
      }
      setDestQuery('');
      setDestActive(0);
      setDestDropdownOpen(false);
    },
    [destinations]
  );

  const removeDest = useCallback((countryId) => {
    setDestinations((prev) => prev.filter((d) => d !== String(countryId)));
  }, []);

  const addState = useCallback(
    (stateId) => {
      const idStr = String(stateId);
      if (!residenceStates.includes(idStr)) {
        setResidenceStates((prev) => [...prev, idStr]);
      }
      setStateQuery('');
      setStateActive(0);
      setStateDropdownOpen(false);
    },
    [residenceStates]
  );

  const removeState = useCallback((stateId) => {
    setResidenceStates((prev) => prev.filter((s) => s !== String(stateId)));
  }, []);

  const applyPromo = useCallback(() => {
    const code = promoInput.trim().toUpperCase();
    if (code) {
      setAppliedCouponCode(code);
      setPromoApplied({ code });
      setPromoError(false);
      setIsApplyingPromo(true);
    } else {
      setAppliedCouponCode('');
      setPromoApplied(null);
      setPromoError(true);
      setIsApplyingPromo(false);
    }
  }, [promoInput]);

  const getPhoneWidget = useCallback(
    (key) => {
      const phoneState = phones[key] || { countryCode: 'US', dialCode: '1', value: '' };
      return {
        country: phoneState.countryCode ? phoneState.countryCode.toLowerCase() : 'us',
        countryCode: phoneState.countryCode || 'US',
        value: phoneState.value || '',
        onChange: (value, countryData, _e, formattedValue) => {
          setPhones((prev) => {
            const prevState = prev[key] || { countryCode: 'US', dialCode: '1', value: '' };
            // Only update the country code when the user explicitly selects
            // a new country from the dropdown (dial code changes).
            // This prevents auto-detection from changing the country while typing.
            const newDialCode = (countryData && countryData.dialCode) || prevState.dialCode || '1';
            const countryChanged = newDialCode !== prevState.dialCode;
            const newPhones = { ...prev };
            newPhones[key] = {
              countryCode: countryChanged
                ? countryData.countryCode
                  ? countryData.countryCode.toUpperCase()
                  : prevState.countryCode
                : prevState.countryCode,
              dialCode: countryChanged ? newDialCode : prevState.dialCode,
              value: value || ''
            };
            return newPhones;
          });
        }
      };
    },
    [phones]
  );

  const removeFamilyMember = useCallback((removeIndex) => {
    const shiftMemberKeys = (obj) => {
      const entries = Object.entries(obj || {})
        .filter(([key]) => key.startsWith('fm'))
        .map(([key, value]) => ({ index: Number(key.slice(2)), value }))
        .sort((a, b) => a.index - b.index);

      const next = {};
      let nextIndex = 0;
      for (const entry of entries) {
        if (entry.index === removeIndex) continue;
        next['fm' + nextIndex] = entry.value;
        nextIndex += 1;
      }
      return next;
    };

    setFamilyNames((prev) => shiftMemberKeys(prev));
    setFamilyEmails((prev) => shiftMemberKeys(prev));
    setFamilyDobs((prev) => shiftMemberKeys(prev));
    setFamilyAddr((prev) => shiftMemberKeys(prev));
    setFamilyMinor((prev) => shiftMemberKeys(prev));
    setFamilyUserIds((prev) => shiftMemberKeys(prev));
    setPhones((prev) => {
      const next = { primary: prev.primary };
      const entries = Object.entries(prev)
        .filter(([key]) => key.startsWith('fm'))
        .map(([key, value]) => ({ index: Number(key.slice(2)), value }))
        .sort((a, b) => a.index - b.index);

      let nextIndex = 0;
      for (const entry of entries) {
        if (entry.index === removeIndex) continue;
        next['fm' + nextIndex] = entry.value;
        nextIndex += 1;
      }
      return next;
    });

    setFamilyCount((prevCount) => {
      if (prevCount <= 1) {
        setCoverageType('individual');
        setFamilyNames({});
        setFamilyEmails({});
        setFamilyDobs({});
        setFamilyAddr({});
        setFamilyMinor({});
        setFamilyUserIds({});
        setPhones((prev) => ({ primary: prev.primary }));
        return 0;
      }
      return prevCount - 1;
    });
  }, []);

  // --- Validation & Derived Display Values ---
  const days = daysCount;
  const travelersCount = travelers;
  const durLabel = annual ? 'Annual coverage' : days > 0 ? days + (days === 1 ? ' day' : ' days') : '';
  const todayDateStr = todayStr();
  const departureInPast = !!departure && departure < todayDateStr;
  const returnInPast = !!returnDate && returnDate < todayDateStr;
  const dateInvalid = !annual && !!departure && !!returnDate && new Date(returnDate) <= new Date(departure);
  const durationExceeded = !annual && !!departure && !!returnDate && inclusiveDaysBetween(departure, returnDate) > 365;

  const needsState = residencyIsUS && destinationsIncludeUS;
  const step1Valid =
    !!residency &&
    destinations.length > 0 &&
    (!needsState || residenceStates.length > 0) &&
    (annual ||
      (!annual &&
        !!departure &&
        !!returnDate &&
        !dateInvalid &&
        !durationExceeded &&
        !departureInPast &&
        !returnInPast)) &&
    (coverageType === 'individual' || familyCount >= 1);

  const formattedDestinations = selectedDestinations.map((dest) => {
    if (dest.countryCode === 'US' && residencyIsUS && selectedStateNames.length > 0) {
      return `United States (${selectedStateNames.join(', ')})`;
    }
    return dest.countryName;
  });

  const destSummary =
    formattedDestinations.length === 0
      ? '—'
      : formattedDestinations.length <= 2
      ? formattedDestinations.join(', ')
      : formattedDestinations.slice(0, 2).join(', ') + ' +' + (formattedDestinations.length - 2);

  const emailEntered = email.indexOf('@') !== -1 && email.indexOf('.') !== -1;
  const emailExists = emailEntered && primaryEmailExists;
  const emailNew = emailEntered && !emailExists && !emailChecking;
  const primaryCountryCode = phones.primary && phones.primary.countryCode ? phones.primary.countryCode : 'US';
  const primaryPhoneValue = phones.primary && phones.primary.value ? phones.primary.value : '';
  const nameValid = !!fullName.trim();
  const emailValid = isValidEmail(email);
  const phoneValid = validatePhoneForCountry(primaryPhoneValue, primaryCountryCode);
  const ageVal = ageFromDob(dob);
  const dobValid = ageVal !== null && ageVal >= 0 && ageVal <= 120;
  const isMinor = ageVal !== null && ageVal < 18;
  const addrValid = !!address.trim();
  // Existing-email purchases no longer need a password at all — the account
  // is auto-filled and linked by email alone. Only a brand-new account needs one.
  const pwValid = !emailNew || (password.length >= 6 && password === confirmPassword);
  const parentalOk = !isMinor || parental;

  let baseDetailsValid =
    nameValid && emailValid && phoneValid && dobValid && addrValid && pwValid && agreeTerms && parentalOk;
  let familyValid = true;
  if (coverageType === 'family') {
    const memberCount = Math.max(1, familyCount);
    for (let i = 0; i < memberCount; i++) {
      const key = 'fm' + i;
      const isMinorMember = !!familyMinor[key];
      const mName = familyNames[key] || '';
      const mDob = familyDobs[key] || '';
      const mAge = ageFromDob(mDob);
      const nameOk = !!mName.trim();
      const dobOk = mAge !== null && mAge >= 0 && mAge <= 120;

      let emailOk = true;
      let phoneOk = true;
      if (!isMinorMember) {
        emailOk = isValidEmail(familyEmails[key] || '');
        const memberCountryCode = phones[key] && phones[key].countryCode ? phones[key].countryCode : 'US';
        const memberPhoneVal = phones[key] && phones[key].value ? phones[key].value : '';
        phoneOk = validatePhoneForCountry(memberPhoneVal, memberCountryCode);
      }

      const hasDiffAddr = familyAddr.hasOwnProperty(key);
      const mAddrOk = !hasDiffAddr || !!(familyAddr[key] || '').trim();

      if (!nameOk || !dobOk || !emailOk || !phoneOk || !mAddrOk) {
        familyValid = false;
        break;
      }
    }
  }
  const detailsValid = baseDetailsValid && familyValid;

  const chosenPlan = domesticOnly ? 'domestic' : plan;
  const productInfoList = useMemo(() => {
    const list = [...(props.productInfo || [])];
    staticProducts.forEach((p) => {
      if (!list.find((item) => item.productId === p.productId)) {
        list.push(p);
      }
    });
    return list;
  }, [props.productInfo, staticProducts]);

  const findProductIdByPlan = useCallback(
    (planKey) => {
      const target = String(planKey || '').toLowerCase();
      const match = productInfoList.find((product) => {
        const productName = String(product.productName || product.name || '').toLowerCase();
        if (target === 'domestic') return productName.includes('domestic');
        if (target === 'medical') return productName.includes('medical');
        return productName.includes('complete');
      });
      if (match) return Number(match.productId);
      if (productInfoList.length > 0) return Number(productInfoList[0].productId);
      return null;
    },
    [productInfoList]
  );

  const selectedProductId = useMemo(() => findProductIdByPlan(chosenPlan), [findProductIdByPlan, chosenPlan]);
  const planName =
    chosenPlan === 'complete' ? 'CAP Total Assist' : chosenPlan === 'medical' ? 'CAP Medical Assist' : 'CAP Domestic';
  const pricingStartDate =
    orderSummaryPricing && orderSummaryPricing.startDate
      ? orderSummaryPricing.startDate
      : annual
      ? todayStr()
      : departure;
  const pricingReturnDate =
    orderSummaryPricing && orderSummaryPricing.returnDate ? orderSummaryPricing.returnDate : displayReturnDate;
  const summaryCoverage = annual ? (
    'Annual'
  ) : pricingStartDate && pricingReturnDate ? (
    <>
      {fmtDate(pricingStartDate)} &ndash; <br />
      {fmtDate(pricingReturnDate)}
    </>
  ) : days > 0 ? (
    <>
      {fmtDate(departure)} &ndash; <br />
      {fmtDate(displayReturnDate)}
    </>
  ) : (
    '—'
  );
  const pricingProducts = (orderSummaryPricing && orderSummaryPricing.products) || [];
  const cardProducts = (cardPricing && cardPricing.products) || [];
  const selectedProductPricing =
    pricingProducts.find((p) => p.productId === selectedProductId) ||
    (pricingProducts.length > 0 ? pricingProducts[0] : null);
  const selectedProductFinal = selectedProductPricing ? Number(selectedProductPricing.finalPrice || 0) : 0;
  const domAddOn = Number(orderSummaryPricing && orderSummaryPricing.domesticAddOnPlanAmount);
  const grand = Number((orderSummaryPricing && orderSummaryPricing.totalAmount) || 0);
  const discount = Number((orderSummaryPricing && orderSummaryPricing.discountAmount) || 0);
  const subtotal = Number(selectedProductFinal || 0);
  const couponCodeUsed = (orderSummaryPricing && orderSummaryPricing.couponCode) || '';
  const couponDiscountVal = (orderSummaryPricing && orderSummaryPricing.couponDiscount) || '';
  const hasCouponDiscount = discount > 0 && !!couponCodeUsed;
  let perDaySummary = 'NA';
  if (
    orderSummaryPricing &&
    orderSummaryPricing.perDayPrice !== undefined &&
    orderSummaryPricing.perDayPrice !== null
  ) {
    const perDayValue = Number(orderSummaryPricing.perDayPrice);
    perDaySummary = money(perDayValue) + '/day' + (travelersCount > 1 ? ' · ' + travelersCount + ' travelers' : '');
  }

  const getPriceByPlan = (planKey) => {
    const target = String(planKey || '').toLowerCase();
    let prod = cardProducts.find((p) => {
      const productName = String(p.productName || p.name || '').toLowerCase();
      if (target === 'domestic') return productName.includes('domestic');
      if (target === 'medical') return productName.includes('medical');
      return productName.includes('complete');
    });
    if (!prod && cardProducts.length > 0) prod = cardProducts[0];
    return prod ? Number(prod.finalPrice || 0) : 0;
  };

  const medicalPrice = getPriceByPlan('medical');
  const completePrice = getPriceByPlan('complete');
  const domesticPrice = getPriceByPlan('domestic');
  const canShowPricing = !!cardPricing && !cardPricingLoading;
  const canContinueFromStep2 = !pricingLoading && !!orderSummaryPricing;
  const summaryPlanSub =
    chosenPlan === 'complete'
      ? 'Medical + full security'
      : chosenPlan === 'medical'
      ? 'Medical crisis response'
      : 'U.S. domestic crisis response';

  const stepLabel = 'Step ' + Math.min(step, 3) + ' of 3';
  const stepTitle =
    step === 1 ? 'Trip details' : step === 2 ? 'Choose your plan' : step === 3 ? 'Details & payment' : 'Confirmed';
  const showSummary = step === 2 || step === 3;

  const primaryPhone = getPhoneWidget('primary');

  useEffect(() => {
    async function fetchCardPricing() {
      if (!props.calculatePricing) return;
      if (step < 2 || step > 3) return;
      if (!step1Valid) return;

      const payload = {
        residencyCountry: String(residency),
        destinations: destinations.map((id) => Number(id)),
        states: residenceStates.map((id) => Number(id)),
        domesticCoverage: !!domesticAddon,
        isAnnual: !!annual,
        currency: 'USD',
        travellerCount: travelersCount,
        startDate: annual ? todayStr() : departure,
        isDomestic: !!domesticOnly,
        coupon: appliedCouponCode || null
      };
      if (!annual && displayReturnDate) {
        payload.returnDate = displayReturnDate;
      }

      setCardPricingLoading(true);
      const response = await props.calculatePricing(payload);
      setCardPricingLoading(false);

      const pricingData = response && response.data ? response.data : response;
      if (!pricingData || pricingData.error) {
        setCardPricing(null);
        return;
      }
      setCardPricing(pricingData);
    }
    fetchCardPricing();
  }, [
    step,
    step1Valid,
    residency,
    destinations,
    residenceStates,
    domesticEligible,
    domesticAddon,
    domesticOnly,
    annual,
    travelersCount,
    departure,
    displayReturnDate,
    appliedCouponCode,
    props.calculatePricing
  ]);

  useEffect(() => {
    async function fetchOrderSummaryPricing() {
      if (!props.getOrderSummaryPricing) return;
      if (step < 2 || step > 3) {
        setIsApplyingPromo(false);
        return;
      }
      if (!step1Valid) {
        setIsApplyingPromo(false);
        return;
      }
      if (!selectedProductId) {
        setIsApplyingPromo(false);
        return;
      }

      const payload = {
        residencyCountry: String(residency),
        destinations: destinations.map((id) => Number(id)),
        states: residenceStates.map((id) => Number(id)),
        domesticCoverage: !!domesticAddon,
        isAnnual: !!annual,
        currency: 'USD',
        travellerCount: travelersCount,
        startDate: annual ? todayStr() : departure,
        products: [{ productId: Number(selectedProductId) }],
        coupon: appliedCouponCode || null
      };
      if (!annual && displayReturnDate) {
        payload.returnDate = displayReturnDate;
      }

      const requestId = pricingRequestRef.current + 1;
      pricingRequestRef.current = requestId;
      setPricingLoading(true);
      const response = await props.getOrderSummaryPricing(payload);
      if (requestId !== pricingRequestRef.current) return;
      setPricingLoading(false);
      setIsApplyingPromo(false);

      const pricingData = response && response.data ? response.data : response;
      if (!pricingData || pricingData.error) {
        setOrderSummaryPricing(null);
        if (appliedCouponCode) setPromoError(true);
        return;
      }

      setOrderSummaryPricing(pricingData);
      if (appliedCouponCode) {
        const validCoupon = !!pricingData.couponCode && Number(pricingData.discountAmount || 0) > 0;
        setPromoError(!validCoupon);
      } else {
        setPromoError(false);
      }
    }
    fetchOrderSummaryPricing();
  }, [
    props.getOrderSummaryPricing,
    step,
    step1Valid,
    selectedProductId,
    residency,
    destinations,
    residenceStates,
    domesticEligible,
    domesticAddon,
    domesticOnly,
    annual,
    travelersCount,
    departure,
    displayReturnDate,
    appliedCouponCode
  ]);

  // ─── Create the Stripe PaymentIntent as soon as step 3 is reached ────────
  // No longer waits on name/email — those are sent later via updatePaymentIntent
  // once the customer fills them in. The clientSecret state and the in-flight
  // ref together ensure only one create request is ever made per amount.
  const paymentIntentInFlight = useRef(false);

  // Rebuilt every render so it always closes over the current email/name/grand;
  // held in a ref so effects can call it without re-running on its identity.
  const ensurePaymentIntent = (overrides) => {
    const emailNow = String((overrides && overrides.email) || email || '').trim();
    const nameNow = String((overrides && overrides.name) || fullName || '').trim();

    if (step !== 3 || grand <= 0 || clientSecret || paymentIntentInFlight.current) return;

    paymentIntentInFlight.current = true;
    props
      .createPaymentIntent({
        amount: grand.toFixed(2),
        currency: 'usd',
        customerName: nameNow,
        customerEmail: emailNow
      })
      .then(function(intentRes) {
        if (intentRes && !intentRes.error && intentRes.clientSecret) {
          setClientSecret(intentRes.clientSecret);
          setPaymentIntentId(intentRes.paymentIntentId || '');
        } else {
          paymentIntentInFlight.current = false; // allow a retry
          setPayError('Could not initialise secure payment connection. Please refresh.');
        }
      })
      .catch(function() {
        paymentIntentInFlight.current = false; // allow a retry
        setPayError('An unexpected error occurred connecting to payment provider.');
      });
  };
  const ensurePaymentIntentRef = useRef(ensurePaymentIntent);
  ensurePaymentIntentRef.current = ensurePaymentIntent;

  // Email already answered via the popup — skip re-checking it.
  const resolvedEmailRef = useRef('');

  // Handle email blur to validate via API
  const handleEmailBlur = useCallback(async () => {
    setTouched((prev) => ({ ...prev, email: true }));
    const isValid = isValidEmail(email);
    if (isValid && email === resolvedEmailRef.current) {
      updatePaymentIntentRef.current();
      return;
    }
    let shouldUpdateIntent = true;
    if (isValid && props.validateTravellerEmail) {
      setEmailChecking(true);
      try {
        if (props.flushEmailCheckResponse) {
          await props.flushEmailCheckResponse();
        }
        const response = await props.validateTravellerEmail(email);
        if (response && response.userExist) {
          setPrimaryEmailExists(true);
          setAvailableMembers(response.members || []);
          const name = ((response.firstName || '') + ' ' + (response.lastName || '')).trim();
          setPendingAccountName(name);
          setShowExistingAccountNotice(true);
          shouldUpdateIntent = false; // Continue/Cancel will handle it
        } else {
          setPrimaryEmailExists(false);
          setAvailableMembers([]);
        }
      } catch (e) {
        // API error handled silently
      } finally {
        setEmailChecking(false);
      }
    }
    if (shouldUpdateIntent) {
      updatePaymentIntentRef.current();
    }
  }, [email, props.validateTravellerEmail, props.flushEmailCheckResponse]);

  const handleExistingAccountContinue = useCallback(() => {
    resolvedEmailRef.current = email;
    setShowExistingAccountNotice(false);
    if (pendingAccountName) {
      setFullName(pendingAccountName);
      updatePaymentIntentRef.current({ name: pendingAccountName }); // fullName state update is async — pass it through
    }
    setPrimaryNameLocked(true);
  }, [email, pendingAccountName]);

  const handleExistingAccountCancel = useCallback(() => {
    resolvedEmailRef.current = email;
    setShowExistingAccountNotice(false);
    setPendingAccountName('');
    setPrimaryNameLocked(false);
    setPrimaryEmailExists(false);
    setAvailableMembers([]);
    setEmail('');
    setFullName('');
    setTouched((prev) => ({ ...prev, email: false, name: false }));
  }, [email]);

  // Blur any focused field when a popup opens, so clicking Continue/Cancel
  // can't trigger that field's own blur handler.
  useEffect(() => {
    if ((showExistingAccountNotice || showFamilyAccountNotice) && typeof document !== 'undefined' && document.activeElement) {
      document.activeElement.blur();
    }
  }, [showExistingAccountNotice, showFamilyAccountNotice]);

  // Handle family email blur
  const familyResolvedEmailRef = useRef({});

  const handleFamilyEmailBlur = useCallback(
    async (memberKey, memberEmail) => {
      if (!memberEmail) return;
      const isValid = isValidEmail(memberEmail);
      if (!isValid) return;
      if (memberEmail === familyResolvedEmailRef.current[memberKey]) return;
      if (props.validateTravellerEmail) {
        try {
          const response = await props.validateTravellerEmail(memberEmail);
          if (response && response.userExist) {
            setFamilyEmailExists((prev) => ({ ...prev, [memberKey]: true }));
            const name = ((response.firstName || '') + ' ' + (response.lastName || '')).trim();
            setFamilyPendingInfo((prev) => ({
              ...prev,
              [memberKey]: { name, userId: response.userId || null }
            }));
            setShowFamilyAccountNotice(memberKey);
          } else {
            setFamilyEmailExists((prev) => ({ ...prev, [memberKey]: false }));
          }
        } catch (e) {
          // API error handled silently
        }
      }
    },
    [props.validateTravellerEmail]
  );

  const handleFamilyAccountContinue = useCallback(
    (memberKey) => {
      familyResolvedEmailRef.current[memberKey] = familyEmails[memberKey] || '';
      setShowFamilyAccountNotice(null);
      const pending = familyPendingInfo[memberKey];
      if (pending) {
        if (pending.name) {
          setFamilyNames((prev) => ({ ...prev, [memberKey]: pending.name }));
        }
        if (pending.userId) {
          setFamilyUserIds((prev) => ({ ...prev, [memberKey]: pending.userId }));
        }
      }
      setFamilyNameLocked((prev) => ({ ...prev, [memberKey]: true }));
    },
    [familyEmails, familyPendingInfo]
  );

  const handleFamilyAccountCancel = useCallback(
    (memberKey) => {
      familyResolvedEmailRef.current[memberKey] = familyEmails[memberKey] || '';
      setShowFamilyAccountNotice(null);
      setFamilyPendingInfo((prev) => {
        const next = { ...prev };
        delete next[memberKey];
        return next;
      });
      setFamilyEmailExists((prev) => ({ ...prev, [memberKey]: false }));
      setFamilyEmails((prev) => ({ ...prev, [memberKey]: '' }));
      setFamilyNames((prev) => ({ ...prev, [memberKey]: '' }));
      setFamilyNameLocked((prev) => ({ ...prev, [memberKey]: false }));
      setTouched((prev) => ({ ...prev, [memberKey + '_email']: false, [memberKey + '_name']: false }));
    },
    [familyEmails]
  );

  const handleSelectAvailableMember = useCallback(
    (member, isSelected) => {
      if (isSelected) {
        setCoverageType('family');
        setFamilyCount((prevCount) => {
          const nextCount = Math.max(1, prevCount + 1);
          const newKey = 'fm' + (nextCount - 1);
          setFamilyUserIds((prev) => ({ ...prev, [newKey]: member.userId }));
          setFamilyNames((prev) => ({
            ...prev,
            [newKey]: ((member.firstName || '') + ' ' + (member.lastName || '')).trim()
          }));
          if (member.dateOfBirth) {
            setFamilyDobs((prev) => ({ ...prev, [newKey]: member.dateOfBirth.split('T')[0] }));
          }
          if (member.email) {
            setFamilyEmails((prev) => ({ ...prev, [newKey]: member.email }));
          }
          if (member.contactNo) {
            const rawValue = member.contactNo || '';
            const digits = rawValue.replace(/\D/g, '');
            setPhones((prev) => ({
              ...prev,
              [newKey]: {
                countryCode: 'US',
                dialCode: '1',
                value: rawValue.startsWith('+') ? rawValue : digits ? '+' + digits : rawValue
              }
            }));
          }
          return nextCount;
        });
      } else {
        const entry = Object.entries(familyUserIds).find(([k, v]) => v === member.userId);
        if (entry) {
          const removeIndex = Number(entry[0].slice(2));
          removeFamilyMember(removeIndex);
        }
      }
    },
    [familyUserIds, removeFamilyMember]
  );

  const parseDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value !== 'string') return null;

    const isoMatch = value.match(/^\d{4}-\d{2}-\d{2}$/);
    if (isoMatch) {
      const [year, month, day] = value.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    const displayMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (displayMatch) {
      const [, month, day, year] = displayMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    return null;
  };

  const formatDateValue = (value) => {
    const parsed = parseDateValue(value);
    if (!parsed) return '';
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // ─── Build final order payload (B2C format) ───────────────────────────────
  // Called after successful payment; piId comes from Stripe PaymentIntent.
  const buildOrderPayload = useCallback(
    function(piId, overrides) {
      const nameForPayload = (overrides && overrides.fullName) || fullName;
      const emailForPayload = (overrides && overrides.email) || email;

      // Determine the phone contact number with dial code
      const primaryPhone = phones.primary || {};
      const normalizedPrimary = String(primaryPhone.value || '');
      const contactNo = normalizedPrimary.startsWith('+')
        ? normalizedPrimary
        : normalizedPrimary
        ? '+' + normalizedPrimary
        : '';

      // Primary traveller object
      const primaryTraveller = {
        FirstName: nameForPayload.split(' ')[0] || nameForPayload,
        LastName:
          nameForPayload
            .split(' ')
            .slice(1)
            .join(' ') || '',
        Email: emailForPayload,
        ContactNo: contactNo,
        Country: Number(residency),
        State: residenceStates.length > 0 ? Number(residenceStates[0]) : 0,
        DOB: dob,
        ProductId: selectedProductId,
        IsPrimary: true,
        Address: address,
        ...(password ? { password: password } : {})
      };

      // Family members
      const familyTravellers = [];
      if (coverageType === 'family') {
        const memberCount = Math.max(1, familyCount);
        for (let i = 0; i < memberCount; i++) {
          const key = 'fm' + i;
          const memberName = familyNames[key] || '';
          const memberPhone = phones[key] || {};
          const normalizedMember = String(memberPhone.value || '');
          const mContactNo = normalizedMember.startsWith('+')
            ? normalizedMember
            : normalizedMember
            ? '+' + normalizedMember
            : '';
          const isMinor = !!familyMinor[key];

          familyTravellers.push({
            FirstName: memberName.split(' ')[0] || memberName,
            LastName:
              memberName
                .split(' ')
                .slice(1)
                .join(' ') || '',
            Email: isMinor ? '' : familyEmails[key] || '',
            ContactNo: isMinor ? '' : mContactNo,
            Country: Number(residency),
            State: residenceStates.length > 0 ? Number(residenceStates[0]) : 0,
            DOB: familyDobs[key] || '',
            ProductId: selectedProductId,
            IsPrimary: false,
            IsMinor: isMinor,
            Address: familyAddr.hasOwnProperty(key) ? familyAddr[key] : address,
            UserID: familyUserIds[key] ? familyUserIds[key] : null
          });
        }
      }

      const allTravellers = [primaryTraveller].concat(familyTravellers);
      const totalAmountStr = grand.toFixed(2);

      return {
        userinfo: allTravellers,
        isAnnual: !!annual,
        Countries: destinations.map(function(id) {
          return String(id);
        }),
        CoverageStartDate: annual ? todayStr() : departure,
        CoverageEndDate: displayReturnDate,
        Quantity: travelersCount,
        TotalOrderAmount: totalAmountStr,
        discount: discount > 0 ? discount : null,
        CouponCode: appliedCouponCode || null,
        IsReceiveTravelAlerts: true,
        states: residenceStates.map(function(id) {
          return Number(id);
        }),
        Currency: 'USD',
        ConversionTotalAmount: totalAmountStr,
        PaymentIntentId: piId || '',
        DomesticCoverage: !!domesticAddon,
        utm_source: utmSource || null,
        utm_medium: utmMedium || null,
        utm_campaign: utmCampaign || null
      };
    },
    [
      fullName,
      email,
      dob,
      phones,
      address,
      selectedProductId,
      coverageType,
      familyCount,
      familyAddr,
      familyMinor,
      chosenPlan,
      annual,
      departure,
      displayReturnDate,
      days,
      residency,
      residencyCountry,
      destinations,
      residenceStates,
      selectedStateRecords,
      domesticEligible,
      domesticAddon,
      domesticOnly,
      travelersCount,
      grand,
      discount,
      appliedCouponCode,
      familyNames,
      familyEmails,
      familyDobs,
      password,
      utmSource,
      utmMedium,
      utmCampaign
    ]
  );

  // ─── Update the PaymentIntent with traveller/order details ──────────────
  // Fires once name + email are both filled in (the intent itself was already
  // created as soon as step 3 was reached, with no customer details yet).
  // Sends the same order-shaped payload buildOrderPayload() builds for
  // submitOrder — just posted to /api/update-payment-intent with the existing
  // PaymentIntentId instead of creating a new order.
  const paymentIntentUpdateInFlight = useRef(false);
  const lastSentIntentDetails = useRef('');

  const updateIntentWithDetails = useCallback(
    function(overrides) {
      // fullName/email state updates from setFullName/setEmail are async, so
      // callers that just called one of those (e.g. auto-fill from an
      // existing-user lookup) can pass the fresh value through directly.
      const emailNow = String((overrides && overrides.email) || email || '').trim();
      const nameNow = String((overrides && overrides.name) || fullName || '').trim();

      if (step !== 3 || !paymentIntentId || !clientSecret) return;
      if (!isValidEmail(emailNow) || !nameNow) return;
      if (paymentIntentUpdateInFlight.current) return;

      // Skip if nothing relevant has changed since the last successful send.
      const signature = emailNow + '|' + nameNow;
      if (signature === lastSentIntentDetails.current) return;

      paymentIntentUpdateInFlight.current = true;
      const payload = buildOrderPayload(paymentIntentId, { fullName: nameNow, email: emailNow });
      props
        .updatePaymentIntent(payload)
        .then(function(res) {
          paymentIntentUpdateInFlight.current = false;
          if (!res || res.error) {
            console.warn('[CAP] update-payment-intent failed:', res);
            return;
          }
          lastSentIntentDetails.current = signature;
        })
        .catch(function() {
          paymentIntentUpdateInFlight.current = false;
        });
    },
    [step, paymentIntentId, clientSecret, email, fullName, buildOrderPayload, props.updatePaymentIntent]
  );
  const updatePaymentIntentRef = useRef(updateIntentWithDetails);
  updatePaymentIntentRef.current = updateIntentWithDetails;

  // Covers the race where the intent finishes being created *after* the
  // customer already blurred name/email (create is now async and no longer
  // gated on those fields, so this can happen on a fast typist / slow network).
  useEffect(() => {
    if (paymentIntentId) {
      updatePaymentIntentRef.current();
    }
  }, [paymentIntentId]);

  // ─── Handle Redirects (e.g. Amazon Pay) ───────────────────────────
  // Redirect-based payment methods navigate the user away and back, wiping React state.
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const redirectStatus = query.get('redirect_status');

    if (redirectStatus) {
      const stateStr = sessionStorage.getItem('cap_quote_state');
      if (stateStr) {
        try {
          const s = JSON.parse(stateStr);
          if (s.residency) setResidency(s.residency);
          if (s.destinations) setDestinations(s.destinations);
          if (s.departure) setDeparture(s.departure);
          if (s.returnDate) setReturnDate(s.returnDate);
          if (s.annual !== undefined) setAnnual(s.annual);
          if (s.coverageType) setCoverageType(s.coverageType);
          if (s.familyCount) setFamilyCount(s.familyCount);
          if (s.plan) setPlan(s.plan);
          if (s.domesticAddon !== undefined) setDomesticAddon(s.domesticAddon);
          if (s.email) setEmail(s.email);
          if (s.payMethod) setPayMethod(s.payMethod);
          if (s.promoInput) setPromoInput(s.promoInput);
          if (s.promoApplied) setPromoApplied(s.promoApplied);
          if (s.appliedCouponCode) setAppliedCouponCode(s.appliedCouponCode);
          if (s.orderSummaryPricing) setOrderSummaryPricing(s.orderSummaryPricing);
          if (s.cardPricing) setCardPricing(s.cardPricing);
          if (s.phones) setPhones(s.phones);
          if (s.familyAddr) setFamilyAddr(s.familyAddr);
          if (s.familyMinor) setFamilyMinor(s.familyMinor);
          if (s.fullName) setFullName(s.fullName);
          if (s.dob) setDob(s.dob);
          if (s.address) setAddress(s.address);
          if (s.agreeTerms !== undefined) setAgreeTerms(s.agreeTerms);
          if (s.parental !== undefined) setParental(s.parental);
          if (s.paymentIntentId) setPaymentIntentId(s.paymentIntentId);
          if (s.utmSource) setUtmSource(s.utmSource);
          if (s.utmMedium) setUtmMedium(s.utmMedium);
          if (s.utmCampaign) setUtmCampaign(s.utmCampaign);
        } catch (e) {
          console.warn('Failed to restore quote state');
        }
      }

      if (redirectStatus === 'succeeded') {
        const pendingOrderStr = sessionStorage.getItem('cap_pending_order');
        if (pendingOrderStr) {
          try {
            const orderPayload = JSON.parse(pendingOrderStr);
            setPayProcessing(true);
            goToStep(3); // make sure we're visually on step 3 while processing
            props
              .submitOrder(orderPayload)
              .then(function(res) {
                sessionStorage.removeItem('cap_pending_order');
                sessionStorage.removeItem('cap_quote_state');
                if (isOrderResponseSuccessful(res)) {
                  goToStep(4);
                } else {
                  setPayError('Order submission failed. Please contact support.');
                }
                setPayProcessing(false);
              })
              .catch(function() {
                setPayError('Order submission failed. Please try again.');
                setPayProcessing(false);
              });
          } catch (e) {
            setPayError('Failed to restore order details after redirect.');
          }
        } else {
          setPayError('Order details lost during redirect. Please try again.');
        }
      } else {
        setPayError('Payment was not successful (Status: ' + redirectStatus + ').');
        goToStep(3);
      }

      // Clean up the URL so a refresh doesn't trigger this again
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [props.submitOrder]);

  // ─── Discard the PaymentIntent if the amount changes ─────────────────────
  // Resets the guards so a fresh one is created for the new amount. Also
  // clears the update-dedup cache: it's keyed only on email|name, so without
  // this a new intent whose customer details happen to match what was last
  // sent to the *old* (now-discarded) intent would silently never get its
  // update-payment-intent call — see the /quote step-2-detour bug.
  useEffect(() => {
    setClientSecret(null);
    setPaymentIntentId(null);
    paymentIntentInFlight.current = false;
    lastSentIntentDetails.current = '';
  }, [grand]);

  // After an amount change clears the clientSecret (or on first reaching step 3),
  // (re)create the intent right away — no longer waits on name/email. Keyed on
  // clientSecret so it runs on the render *after* the discard above.
  useEffect(() => {
    if (step !== 3 || grand <= 0 || clientSecret) return;
    ensurePaymentIntentRef.current();
  }, [grand, clientSecret, step]);

  // ─── Scroll to top on step change ───────────────────────────────────────
  const prevStep = useRef(step);
  useEffect(() => {
    if (prevStep.current !== step) {
      prevStep.current = step;

      if (typeof window !== 'undefined') {
        window.setTimeout(() => {
          scrollQuoteToTop();
          if (progressRef.current) {
            progressRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 120);
      }
    }
  }, [step, scrollQuoteToTop]);

  // ─── Klaviyo: "Viewed Product" — fires once when step transitions to 2 ──
  // Note: email is not available at step 2 (entered on step 3), so no identify call here.
  useEffect(() => {
    if (step === 2 && !klaviyoViewedProductFired.current) {
      klaviyoViewedProductFired.current = true;
      try {
        trackViewedProduct({
          productId: selectedProductId,
          planName: planName,
          destination: destSummary,
          residency: residencyCountry ? residencyCountry.countryName : residency,
          currency: 'USD',
          startDate: pricingStartDate || (annual ? todayStr() : departure),
          endDate: pricingReturnDate || displayReturnDate
        });
      } catch (e) {
        console.warn('[Klaviyo] Viewed Product tracking error:', e);
      }
    }
    // Reset the flag when navigating away from step 2 (allows re-fire on fresh visit)
    if (step !== 2) {
      klaviyoViewedProductFired.current = false;
    }
  }, [step]);

  useEffect(() => {
    if (detailsValid && payError) {
      if (payError.includes('traveller details')) {
        setPayError('');
      }
    }
  }, [detailsValid, payError]);

  // Triggered when user clicks "Place Order" for Stripe (Card/Apple Pay/Google Pay)
  const handleInitiatePayment = useCallback(
    function() {
      if (!detailsValid) {
        setPayError('Please complete all required traveller details before paying.');
        const newTouched = {
          name: true,
          phone: true,
          email: true,
          dob: true,
          address: true,
          password: true,
          confirmPassword: true
        };
        if (coverageType === 'family') {
          const memberCount = Math.max(1, familyCount);
          for (let i = 0; i < memberCount; i++) {
            newTouched['fm' + i + '_name'] = true;
            newTouched['fm' + i + '_email'] = true;
            newTouched['fm' + i + '_dob'] = true;
            newTouched['fm' + i + '_phone'] = true;
            newTouched['fm' + i + '_addr'] = true;
          }
        }
        setTouched(newTouched);
        return;
      }
      if (payProcessing) return;
      setPayError('');
      setPayProcessing(true);

      // ─── Klaviyo: "Checkout Started" — fires when user clicks "Place order" ───
      try {
        trackCheckoutStarted({
          productId: selectedProductId,
          planName: planName,
          destination: destSummary,
          residency: residencyCountry ? residencyCountry.countryName : residency,
          amount: grand,
          currency: 'USD',
          email: email || undefined,
          firstName: fullName ? fullName.split(' ')[0] : undefined,
          lastName: fullName
            ? fullName
                .split(' ')
                .slice(1)
                .join(' ')
            : undefined,
          startDate: pricingStartDate || (annual ? todayStr() : departure),
          endDate: pricingReturnDate || displayReturnDate,
          quoteId: paymentIntentId || undefined,
          paymentStatus: 'pending'
        });
      } catch (e) {
        console.warn('[Klaviyo] Checkout Started tracking error:', e);
      }

      // Save payload and full state to sessionStorage in case the payment method redirects (e.g. Amazon Pay)
      if (paymentIntentId) {
        const payload = buildOrderPayload(paymentIntentId);
        sessionStorage.setItem('cap_pending_order', JSON.stringify(payload));

        const stateObj = {
          residency,
          destinations,
          departure,
          returnDate,
          annual,
          coverageType,
          familyCount,
          plan,
          domesticAddon,
          email,
          payMethod,
          promoInput,
          promoApplied,
          appliedCouponCode,
          orderSummaryPricing,
          cardPricing,
          phones,
          familyAddr,
          familyMinor,
          fullName,
          dob,
          address,
          agreeTerms,
          parental,
          paymentIntentId,
          utmSource,
          utmMedium,
          utmCampaign
        };
        sessionStorage.setItem('cap_quote_state', JSON.stringify(stateObj));
      }

      // Trigger the hidden Stripe form submit inside StripePaymentForm
      setTimeout(function() {
        const stripeBtn = document.getElementById('cap-stripe-submit');
        if (stripeBtn) stripeBtn.click();
        else {
          setPayError('Payment form not ready. Please try again.');
          setPayProcessing(false);
        }
      }, 100);
    },
    [
      detailsValid,
      payProcessing,
      paymentIntentId,
      buildOrderPayload,
      emailExists,
      residency,
      residencyCountry,
      destinations,
      departure,
      returnDate,
      annual,
      coverageType,
      familyCount,
      plan,
      domesticAddon,
      email,
      payMethod,
      promoInput,
      promoApplied,
      appliedCouponCode,
      orderSummaryPricing,
      cardPricing,
      phones,
      familyAddr,
      familyMinor,
      fullName,
      dob,
      address,
      agreeTerms,
      parental
    ]
  );

  // ─── Step 2: After Stripe confirms payment, submit order ────────────────
  const handleStripePaymentSuccess = useCallback(
    function(stripePaymentIntentId) {
      // Use the paymentIntentId from our backend if available, else from Stripe
      const piId = paymentIntentId || stripePaymentIntentId;
      const orderPayload = buildOrderPayload(piId);
      console.log('[CAP] Order payload (stripe / submitorderForB2C):', JSON.stringify(orderPayload, null, 2));

      props
        .submitOrder(orderPayload)
        .then(function(orderRes) {
          if (isOrderResponseSuccessful(orderRes)) {
            // Initialize pixel (safe to call multiple times) and track Purchase
            try {
              initFacebookPixel('988888358335226');
              trackFacebookPurchase({
                value: orderPayload.TotalOrderAmount,
                currency: orderPayload.Currency || 'USD',
                content_type: 'product',
                content_ids: [String(selectedProductId || '')],
                num_items: orderPayload.Quantity || 1,
                content_name: planName || undefined
              });
            } catch (e) {
              console.warn('[FB Pixel] tracking failed', e);
            }

            goToStep(4);
          } else {
            setPayError('Order submission failed. Please contact support.');
          }
          setPayProcessing(false);
        })
        .catch(function() {
          setPayError('Order submission failed. Please try again.');
          setPayProcessing(false);
        });
    },
    [
      paymentIntentId,
      buildOrderPayload,
      props.submitOrder,
      selectedProductId,
      planName,
      destSummary,
      grand,
      email,
      pricingStartDate,
      pricingReturnDate,
      annual,
      departure,
      displayReturnDate
    ]
  );

  // ─── Handle Stripe payment error ────────────────────────────────────────
  const handleStripePaymentError = useCallback(function(errorMsg) {
    if (errorMsg === '') {
      setPayError('');
    } else {
      setPayError(errorMsg || 'Payment failed. Please try again.');
    }
    setPayProcessing(false);
  }, []);

  return (
    <div className='cap-root'>
      {/* HEADER */}
      <header className='cap-header'>
        <div className='cap-header-inner'>
          <div className='cap-brand'>
            <img
              style={{ width: '100px', height: 'auto' }}
              src={logo}
              alt='CAP Advantage'
              className='cap-brand__logo'
            />
          </div>
          <a href='https://www.captravelassistance.com/help-center/' className='cap-need-help'>
            <HelpIcon />
            Need help?
          </a>
        </div>
      </header>

      {/* PROGRESS + TRUST */}
      <div className='cap-progress' ref={progressRef}>
        <div className='cap-progress-inner'>
          <div className='cap-progress-left'>
            <div className='cap-progress-steprow'>
              <span className='cap-step-label'>{stepLabel}</span>
              <span className='cap-step-title'>{stepTitle}</span>
            </div>
            <div className='cap-progress-bars'>
              <span className={'cap-progress-bar' + (step >= 1 ? ' cap-progress-bar--active' : '')} />
              <span className={'cap-progress-bar' + (step >= 2 ? ' cap-progress-bar--active' : '')} />
              <span className={'cap-progress-bar' + (step >= 3 ? ' cap-progress-bar--active' : '')} />
            </div>
          </div>
          {/* {step === 1 &&
          <div className='cap-trust'>
            <span className='cap-trust__item'>
              <ShieldIcon color='#56B947' />
              Lloyd's of London
            </span>
            <span>★★★★★ </span>
            <span>Trusted by 500,000+ travelers</span>
          </div>
          } */}
        </div>
      </div>

      {/* BODY */}
      <div className='cap-body'>
        <div className={'cap-grid' + (showSummary ? ' cap-grid--with-sidebar' : '')}>
          {/* MAIN COLUMN */}
          <div className='cap-main'>
            {/* STEP 1 */}
            {step === 1 && (
              <React.Fragment>
                <div className='cap-step-head'>
                  <h1 className='cap-h1 cap-h1--navy'>
                    Tell us about your <Highlight>trip.</Highlight>
                  </h1>
                  <p className='cap-lead'>
                    Takes about a minute. We'll price your plan for exactly where you're headed.
                  </p>
                </div>

                <div className='cap-card cap-card--step1'>
                  {/* residency */}
                  <div className='cap-field'>
                    <Lbl>
                      Country of residency <Req />
                    </Lbl>
                    <div className='cap-select-wrap' ref={resRef}>
                      <input
                        className='cap-input cap-field-box'
                        type='text'
                        value={
                          resDropdownOpen
                            ? resQuery
                            : residency && countryById[residency]
                            ? countryById[residency].countryName
                            : ''
                        }
                        onFocus={() => {
                          setResQuery('');
                          setResDropdownOpen(true);
                        }}
                        onClick={() => {
                          setResQuery('');
                          setResDropdownOpen(true);
                        }}
                        onChange={(e) => {
                          setResQuery(e.target.value);
                          setResActive(0);
                          setResDropdownOpen(true);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            setResActive((prev) => Math.min(prev + 1, resMatches.length - 1));
                          } else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            setResActive((prev) => Math.max(prev - 1, 0));
                          } else if (e.key === 'Enter') {
                            e.preventDefault();
                            const chosen = resMatches[resActiveIndex];
                            if (chosen) handleSelectResidency(chosen.countryId);
                          } else if (e.key === 'Escape') {
                            setResQuery('');
                            setResDropdownOpen(false);
                          }
                        }}
                        placeholder='Search and select your country…'
                      />
                      {resDropdownOpen && resMatches.length > 0 && (
                        <div className='cap-autocomplete'>
                          {resMatches.map((countryObj, i) => (
                            <button
                              key={countryObj.countryId}
                              type='button'
                              onClick={() => handleSelectResidency(countryObj.countryId)}
                              onMouseEnter={() => setResActive(i)}
                              className={
                                'cap-autocomplete__item' +
                                (i === resActiveIndex ? ' cap-autocomplete__item--active' : '')
                              }
                            >
                              <span className='cap-autocomplete__pin'>
                                <Pin />
                              </span>
                              <span className='cap-autocomplete__name'>{countryObj.countryName}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* destinations */}
                  <div className='cap-field'>
                    <Lbl>
                      Destination(s) <Req />
                    </Lbl>
                    <div className='cap-select-wrap' ref={destRef}>
                      <input
                        className='cap-input cap-field-box'
                        type='text'
                        value={destQuery}
                        onFocus={() => setDestDropdownOpen(true)}
                        onClick={() => setDestDropdownOpen(true)}
                        onChange={(e) => {
                          setDestQuery(e.target.value);
                          setDestActive(0);
                          setDestDropdownOpen(true);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            setDestActive((prev) => Math.min(prev + 1, matches.length - 1));
                          } else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            setDestActive((prev) => Math.max(prev - 1, 0));
                          } else if (e.key === 'Enter') {
                            e.preventDefault();
                            const chosen = matches[active];
                            if (chosen) addDest(chosen.countryId);
                          } else if (e.key === 'Escape') {
                            setDestQuery('');
                            setDestDropdownOpen(false);
                          }
                        }}
                        placeholder='Search and add destinations…'
                      />
                      {destDropdownOpen && matches.length > 0 && (
                        <div className='cap-autocomplete'>
                          {matches.map((countryObj, i) => (
                            <button
                              key={countryObj.countryId}
                              type='button'
                              onClick={() => addDest(countryObj.countryId)}
                              onMouseEnter={() => setDestActive(i)}
                              className={
                                'cap-autocomplete__item' + (i === active ? ' cap-autocomplete__item--active' : '')
                              }
                            >
                              <span className='cap-autocomplete__pin'>
                                <Pin />
                              </span>
                              <span className='cap-autocomplete__name'>{countryObj.countryName}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    {destinations.length > 0 && (
                      <div className='cap-chips'>
                        {selectedDestinations.map((countryObj) => (
                          <span key={countryObj.countryId} className='cap-chip'>
                            {countryObj.countryName}
                            <button
                              type='button'
                              onClick={() => removeDest(countryObj.countryId)}
                              aria-label='Remove'
                              className='cap-chip__remove'
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* residency state dropdown if USA */}
                  {residencyIsUS && destinationsIncludeUS && (
                    <div className='cap-field'>
                      <Lbl>
                        State(s) <Req />
                      </Lbl>
                      <div className='cap-select-wrap' ref={stateRef}>
                        <input
                          className='cap-input cap-field-box'
                          type='text'
                          value={stateQuery}
                          onFocus={() => setStateDropdownOpen(true)}
                          onClick={() => setStateDropdownOpen(true)}
                          onChange={(e) => {
                            setStateQuery(e.target.value);
                            setStateActive(0);
                            setStateDropdownOpen(true);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'ArrowDown') {
                              e.preventDefault();
                              setStateActive((prev) => Math.min(prev + 1, stateMatches.length - 1));
                            } else if (e.key === 'ArrowUp') {
                              e.preventDefault();
                              setStateActive((prev) => Math.max(prev - 1, 0));
                            } else if (e.key === 'Enter') {
                              e.preventDefault();
                              const chosen = stateMatches[stateActiveIndex];
                              if (chosen) addState(chosen.stateId);
                            } else if (e.key === 'Escape') {
                              setStateQuery('');
                              setStateDropdownOpen(false);
                            }
                          }}
                          placeholder='Search and add states…'
                        />
                        {stateDropdownOpen && stateMatches.length > 0 && (
                          <div className='cap-autocomplete'>
                            {stateMatches.map((st, i) => (
                              <button
                                key={st.stateId || st.stateName}
                                type='button'
                                onClick={() => addState(st.stateId)}
                                onMouseEnter={() => setStateActive(i)}
                                className={
                                  'cap-autocomplete__item' +
                                  (i === stateActiveIndex ? ' cap-autocomplete__item--active' : '')
                                }
                              >
                                <span className='cap-autocomplete__pin'>
                                  <Pin />
                                </span>
                                <span className='cap-autocomplete__name'>{st.stateName}</span>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      {residenceStates.length > 0 && (
                        <div className='cap-chips'>
                          {selectedStateRecords.map((stateObj) => (
                            <span key={stateObj.stateId} className='cap-chip'>
                              {stateObj.stateName}
                              <button
                                type='button'
                                onClick={() => removeState(stateObj.stateId)}
                                aria-label='Remove'
                                className='cap-chip__remove'
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* annual */}
                  <button
                    type='button'
                    onClick={() => setAnnual(!annual)}
                    className={'cap-annual' + (annual ? ' cap-annual--on' : '')}
                  >
                    <span className='cap-annual__text'>
                      <span className='cap-annual__title'>Interested in an annual plan?</span>
                      <span className='cap-annual__sub'>Multi-trip protection for a full year.</span>
                    </span>
                    <span className={'cap-switch' + (annual ? ' cap-switch--on' : '')}>
                      <span className='cap-switch__knob' />
                    </span>
                  </button>

                  {/* dates */}
                  <React.Fragment>
                    <div className='cap-dates-row'>
                      {!annual && (
                        <React.Fragment>
                          <div className='cap-date-col'>
                            <Lbl>
                              Departure <Req />
                            </Lbl>
                            <DatePicker
                              selected={parseDateValue(departure)}
                              onChange={(date) => {
                                const newDeparture = date ? formatDateValue(date) : '';
                                setDeparture(newDeparture);
                                if (returnDate && newDeparture) {
                                  if (returnDate < newDeparture) {
                                    setReturnDate('');
                                  } else {
                                    const days = inclusiveDaysBetween(newDeparture, returnDate);
                                    if (days > 366) setReturnDate('');
                                  }
                                }
                              }}
                              dateFormat='MM/dd/yyyy'
                              placeholderText='MM/DD/YYYY'
                              customInput={<input className='cap-input cap-field-box cap-field-box--date' />}
                              minDate={parseDateValue(todayStr())}
                              maxDate={parseDateValue('2099-12-31')}
                              showPopperArrow={false}
                            />
                          </div>
                          <div className='cap-date-col'>
                            <Lbl>
                              Return <Req />
                            </Lbl>
                            <DatePicker
                              selected={parseDateValue(displayReturnDate)}
                              onChange={(date) => setReturnDate(date ? formatDateValue(date) : '')}
                              dateFormat='MM/dd/yyyy'
                              placeholderText='MM/DD/YYYY'
                              customInput={<input className='cap-input cap-field-box cap-field-box--date' />}
                              minDate={parseDateValue(departure || todayStr())}
                              maxDate={(() => {
                                if (!departure) return parseDateValue('2099-12-31');
                                const d = new Date(departure + 'T00:00:00');
                                if (isNaN(d.getTime())) return parseDateValue('2099-12-31');
                                d.setDate(d.getDate() + 364);
                                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
                              })()}
                              showPopperArrow={false}
                            />
                          </div>
                        </React.Fragment>
                      )}
                      <div className='cap-dur-col'>
                        <div className='cap-dur-label'>{durLabel}</div>
                      </div>
                    </div>
                    {!annual && departureInPast && (
                      <div className='cap-date-error'>Departure date cannot be in the past.</div>
                    )}
                    {!annual && !departureInPast && returnInPast && (
                      <div className='cap-date-error'>Return date cannot be in the past.</div>
                    )}
                    {!annual && !departureInPast && !returnInPast && dateInvalid && (
                      <div className='cap-date-error'>Return date must be after departure.</div>
                    )}
                    {!annual && !departureInPast && !returnInPast && !dateInvalid && durationExceeded && (
                      <div className='cap-date-error'>Trip duration cannot exceed 365 days.</div>
                    )}
                  </React.Fragment>

                  {/* coverage type */}
                  <div className='cap-coverage'>
                    <Lbl>
                      Who's traveling? <Req />
                    </Lbl>
                    <div className='cap-segmented'>
                      {['individual', 'family'].map((typeVal) => (
                        <button
                          key={typeVal}
                          type='button'
                          onClick={() => {
                            setCoverageType(typeVal);
                            if (typeVal === 'individual') {
                              setFamilyCount(0);
                            } else if (familyCount === 0) {
                              setFamilyCount(1);
                            }
                          }}
                          className={
                            'cap-segmented__btn' + (coverageType === typeVal ? ' cap-segmented__btn--active' : '')
                          }
                        >
                          {typeVal === 'individual' ? 'Just me' : 'My family'}
                        </button>
                      ))}
                    </div>
                    {coverageType === 'family' && (
                      <div className='cap-family-count'>
                        <span className='cap-family-count__label'>
                          Additional family members <span className='cap-family-count__note'>(not including you)</span>
                        </span>
                        <div className='cap-counter'>
                          <button
                            type='button'
                            className='cap-counter-btn'
                            onClick={() => {
                              if (familyCount <= 1) {
                                setFamilyCount(0);
                                setCoverageType('individual');
                              } else {
                                setFamilyCount(familyCount - 1);
                              }
                            }}
                          >
                            −
                          </button>
                          <span className='cap-counter__value'>{familyCount}</span>
                          <button
                            type='button'
                            className='cap-counter-btn'
                            onClick={() => setFamilyCount(Math.min(familyCount + 1, 9))}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    type='button'
                    onClick={() => {
                      if (step1Valid) goToStep(2);
                    }}
                    disabled={!step1Valid}
                    className='cap-btn-primary cap-btn-primary--mt'
                  >
                    Continue to plans →
                  </button>
                </div>
              </React.Fragment>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <React.Fragment>
                <BackBtn onClick={() => goToStep(1)}>Trip details</BackBtn>
                <div className='cap-step-head'>
                  <h1 className='cap-h1 cap-h1--navy cap-h1--md'>
                    Choose your <Highlight>plan.</Highlight>
                  </h1>
                  <p className='cap-lead cap-lead--sm'>
                    Priced for {destSummary}
                    {annual ? ' · annual' : days > 0 ? ' · ' + days + ' days' : ''}. Both plans are fully funded — $0
                    out of pocket, no deductibles, no claims.
                  </p>
                </div>

                {/* domestic only */}
                {/* 
                {domesticOnly && (
                  <div className='cap-domestic-card'>
                    <div className='cap-domestic-card__head'>
                      <div className='cap-domestic-card__title-wrap'>
                        <h3 className='cap-domestic-card__title'>CAP Domestic</h3>
                        <span className='cap-domestic-card__sub'>
                          Crisis response for travel 100+ miles from home, within the U.S.
                        </span>
                      </div>
                      <span className='cap-badge-selected'>Selected</span>
                    </div>
                    <div className='cap-domestic-card__body'>
                      <div className='cap-price-row'>
                        <span className='cap-price'>
                          {cardPricingLoading ? (
                            <span style={{ fontSize: '0.6em', opacity: 0.7, fontWeight: 'normal' }}>
                              <SpinnerIcon size={14} />
                            </span>
                          ) : canShowPricing && domesticPrice > 0 ? (
                            money0(domesticPrice)
                          ) : (
                            '—'
                          )}
                        </span>
                      </div>
                      <div className='cap-benefits'>
                        {MED_BENEFITS.map((item) => (
                          <div key={item} className='cap-benefit'>
                            <span className='cap-check-bubble'>
                              <Check size={12} />
                            </span>
                            {item}
                          </div>
                        ))}
                      </div>
                      <a onClick={() => goToStep(1)} className='cap-domestic-card__link'>
                        Also traveling internationally? Add destinations →
                      </a>
                    </div>
                  </div>
                )}
                */}

                {/* core plans */}
                {/* {!domesticOnly && ( */}
                <React.Fragment>
                  <div className='cap-plans'>
                    {/* Medical */}
                    <button
                      type='button'
                      onClick={() => setPlan('medical')}
                      className={'cap-plan-card' + (plan === 'medical' ? ' cap-plan-card--selected' : '')}
                    >
                      <div className='cap-plan-card__top'>
                        <div className='cap-plan-card__header'>
                          <div className='cap-plan-card__id'>
                            <span className='cap-plan-icon'>
                              <MedicalPlanIcon size={23} />
                            </span>
                            <div className='cap-plan-card__titles'>
                              <h3 className='cap-plan-card__title'>CAP Medical Assist</h3>
                              <span className='cap-plan-card__sub'>Medical crisis response</span>
                            </div>
                          </div>
                          <span className={'cap-radio' + (plan === 'medical' ? ' cap-radio--on' : '')}>
                            <span className='cap-radio__dot' />
                          </span>
                        </div>
                        <div className='cap-price-row'>
                          <span className='cap-price cap-price--md'>
                            {cardPricingLoading ? (
                              <span style={{ fontSize: '0.6em', opacity: 0.7, fontWeight: 'normal' }}>
                                <SpinnerIcon size={14} />{' '}
                              </span>
                            ) : canShowPricing && medicalPrice > 0 ? (
                              money0(medicalPrice)
                            ) : (
                              '—'
                            )}
                          </span>
                        </div>
                        <div className='cap-divider' />
                        <div className='cap-plan-benefits'>
                          {MED_BENEFITS.slice(0, 6).map((item) => (
                            <div key={item} className='cap-benefit cap-benefit--sm'>
                              <span className='cap-check-bubble cap-check-bubble--sm'>
                                <Check />
                              </span>
                              {item}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setCompareOpen(true);
                          setTimeout(() => {
                            const target = document.getElementById('compare-section-target');
                            if (target) {
                              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                          }, 150);
                        }}
                        className='cap-plan-warn'
                      >
                        <span className='cap-plan-warn__icon'>
                          <WarningIcon />
                        </span>
                        <span className='cap-plan-warn__text'>
                          Missing security coverage. See what's included in Complete →
                        </span>
                      </div>
                    </button>

                    {/* Complete */}
                    <button
                      type='button'
                      onClick={() => setPlan('complete')}
                      className={
                        'cap-plan-card cap-plan-complete' + (plan === 'complete' ? ' cap-plan-complete--selected' : '')
                      }
                    >
                      <span className='cap-recommended'>★ Recommended</span>
                      <div className='cap-plan-complete__top'>
                        <div className='cap-plan-card__header'>
                          <div className='cap-plan-card__id'>
                            <span className='cap-plan-icon cap-plan-icon--lg'>
                              <CompletePlanIcon />
                            </span>
                            <div className='cap-plan-card__titles'>
                              <h3 className='cap-plan-complete__title'>CAP Total Assist</h3>
                              <span className='cap-plan-complete__sub'>Medical + full security response</span>
                            </div>
                          </div>
                          <span className={'cap-radio-lg' + (plan === 'complete' ? ' cap-radio-lg--on' : '')}>
                            <span className='cap-radio-lg__dot' />
                          </span>
                        </div>
                        <div className='cap-price-row'>
                          <span className='cap-price cap-price--lg'>
                            {cardPricingLoading ? (
                              <span style={{ fontSize: '0.6em', opacity: 0.7, fontWeight: 'normal' }}>
                                <SpinnerIcon size={14} />
                              </span>
                            ) : canShowPricing && completePrice > 0 ? (
                              money0(completePrice)
                            ) : (
                              '—'
                            )}
                          </span>
                        </div>
                        <div className='cap-divider--light' />
                        <div className='cap-complete-plus'>
                          Everything in Medical, <span className='cap-complete-plus__accent'>plus:</span>
                        </div>
                        <div className='cap-plan-benefits'>
                          {COMPLETE_ONLY_BENEFITS.map((item) => (
                            <div key={item} className='cap-benefit cap-benefit--light'>
                              <span className='cap-check-bubble--green'>
                                <Check />
                              </span>
                              {item}
                            </div>
                          ))}
                        </div>
                      </div>
                    </button>
                  </div>

                  {/* per-day upgrade banner */}
                  {plan === 'medical' && (
                    <div className='cap-upgrade'>
                      <span className='cap-upgrade__icon'>
                        <UpArrowIcon />
                      </span>
                      <p className='cap-upgrade__text'>
                        CAP Medical Assist doesn't cover terrorism, political evacuations, or kidnap response.{' '}
                        <strong className='cap-upgrade__strong'>
                          Upgrade to CAP Total Assist for more.
                          {/* {cardPricingLoading ? (
                              <span
                                style={{
                                  display: 'inline-flex',
                                  verticalAlign: 'middle',
                                  opacity: 0.7,
                                }}
                              >
                                <SpinnerIcon size={14} />
                              </span>
                            ) : canShowPricing && cardPricing && cardPricing.upgradePerDay ? (
                              money(cardPricing.upgradePerDay)
                            ) : (
                              ''
                            )} */}
                        </strong>
                      </p>
                    </div>
                  )}

                  <button type='button' onClick={() => setCompareOpen(!compareOpen)} className='cap-compare-toggle'>
                    {compareOpen ? 'Hide benefit comparison ↑' : 'CAP Medical Assist and CAP Total Assist comparison'}
                  </button>

                  {compareOpen && (
                    <React.Fragment>
                      <div id='compare-section-target' style={{ scrollMarginTop: '20px' }}></div>
                      <div className='cap-compare cap-compare-desktop'>
                        <div className='cap-compare__head'>
                          <div className='cap-compare__head-benefit'>Benefit</div>
                          <div className='cap-compare__head-med'>Medical</div>
                          <div className='cap-compare__head-comp'>Total</div>
                        </div>
                        {COMPARE_ROWS.map((row) => (
                          <div
                            key={row.label}
                            className={
                              'cap-compare__row' + (!row.med && row.comp ? ' cap-compare__row--highlight' : '')
                            }
                          >
                            <div className='cap-compare__cell-label'>{row.label}</div>
                            <div className='cap-compare__cell'>
                              {row.med ? (
                                <span className='cap-compare__yes'>
                                  <Check size={14} />
                                </span>
                              ) : (
                                <span className='cap-compare__no'>
                                  <CloseIcon />
                                </span>
                              )}
                            </div>
                            <div className='cap-compare__cell cap-compare__cell--comp'>
                              <span className='cap-compare__yes'>
                                <Check size={14} />
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className='cap-compare-mobile'>
                        <div className='cap-pill-toggle'>
                          <button
                            type='button'
                            className={'cap-pill-btn' + (mobileCompareTab === 'medical' ? ' cap-pill-btn--active' : '')}
                            onClick={() => setMobileCompareTab('medical')}
                          >
                            CAP Medical Assist
                          </button>
                          <button
                            type='button'
                            className={
                              'cap-pill-btn' + (mobileCompareTab === 'complete' ? ' cap-pill-btn--active' : '')
                            }
                            onClick={() => setMobileCompareTab('complete')}
                          >
                            CAP Total Assist
                          </button>
                        </div>
                        <div className='cap-mobile-benefits'>
                          {COMPARE_ROWS.map((row) => {
                            let statusObj = null;
                            if (mobileCompareTab === 'medical') {
                              if (row.med) {
                                statusObj = (
                                  <span className='cap-compare__yes'>
                                    <Check size={14} />
                                  </span>
                                );
                              } else {
                                statusObj = (
                                  <span className='cap-compare__no'>
                                    <CloseIcon />
                                  </span>
                                );
                              }
                            } else {
                              if (row.comp && !row.med) {
                                statusObj = <span className='cap-mobile-benefit__plus'>+</span>;
                              } else if (row.comp) {
                                statusObj = (
                                  <span className='cap-compare__yes'>
                                    <Check size={14} />
                                  </span>
                                );
                              }
                            }
                            return (
                              <div key={row.label} className='cap-mobile-benefit'>
                                <span>{row.label}</span>
                                <div className='cap-mobile-benefit__status'>{statusObj}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </React.Fragment>
                  )}

                  {/* Domestic addon upgrade banner removed as per request */}
                </React.Fragment>
                {/* )} */}

                <button
                  type='button'
                  onClick={() => {
                    // ─── Klaviyo: "Added to Cart" — fires when user selects a plan ───
                    // Note: email is not available at step 2 (entered on step 3), so no identify call here.
                    try {
                      trackAddedToCart({
                        productId: selectedProductId,
                        planName: planName,
                        destination: destSummary,
                        residency: residencyCountry ? residencyCountry.countryName : residency,
                        amount: grand,
                        currency: 'USD',
                        startDate: pricingStartDate || (annual ? todayStr() : departure),
                        endDate: pricingReturnDate || displayReturnDate,
                        quoteParam: quoteParamValue || undefined
                      });
                    } catch (e) {
                      console.warn('[Klaviyo] Added to Cart tracking error:', e);
                    }

                    try {
                      initFacebookPixel('988888358335226');
                      trackFacebookAddToCart({
                        value: grand,
                        currency: 'USD',
                        content_type: 'product',
                        content_ids: [String(selectedProductId || '')],
                        num_items: travelersCount || 1,
                        content_name: planName || undefined,
                        product_id: selectedProductId || undefined,
                        product_name: planName || undefined,
                        destination: destSummary || undefined,
                        residency: residencyCountry ? residencyCountry.countryName : residency || undefined,
                        start_date: pricingStartDate || (annual ? todayStr() : departure) || undefined,
                        end_date: pricingReturnDate || displayReturnDate || undefined
                      });
                    } catch (e) {
                      console.warn('[FB Pixel] AddToCart tracking failed', e);
                    }

                    goToStep(3);
                  }}
                  disabled={!canContinueFromStep2}
                  className='cap-btn-primary'
                >
                  Continue to details →
                </button>
              </React.Fragment>
            )}

            {/* STEP 3 */}
            {step === 3 && (
              <React.Fragment>
                <BackBtn onClick={() => goToStep(2)}>Plans</BackBtn>
                <div className='cap-step-head'>
                  <h1 className='cap-h1 cap-h1--navy cap-h1--md'>
                    Almost <Highlight>there.</Highlight>
                  </h1>
                  <p className='cap-lead cap-lead--sm'>
                    Your details set up your CAP Advantage account and app access.
                  </p>
                </div>

                <div className='cap-card'>
                  <SectionLabel>Your details</SectionLabel>
                  <div className='cap-two-col'>
                    <Field label='Full name' required>
                      <input
                        className={
                          'cap-input cap-field-box-sm' + (touched.name && !nameValid ? ' cap-field-box-sm--error' : '')
                        }
                        type='text'
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        onBlur={() => {
                          setTouched((prev) => ({ ...prev, name: true }));
                          updatePaymentIntentRef.current();
                        }}
                        placeholder='Jane Traveler'
                        disabled={primaryNameLocked}
                      />
                      {touched.name && !nameValid && <ErrText>Please enter your full name.</ErrText>}
                    </Field>
                    <Field label='Phone' required>
                      <PhoneInput
                        country={primaryPhone.country}
                        value={primaryPhone.value}
                        onChange={primaryPhone.onChange}
                        inputClass={
                          'cap-input cap-field-box-sm cap-field-box--phone' +
                          (touched.phone && !phoneValid ? ' cap-field-box-sm--error' : '')
                        }
                        containerClass='cap-phone-input'
                        buttonClass='cap-phone-button'
                        enableSearch
                        disableSearchIcon
                        disableCountryGuess={true}
                        countryCodeEditable={false}
                        placeholder='Enter phone number'
                        inputProps={{
                          onBlur: () => setTouched((prev) => ({ ...prev, phone: true }))
                        }}
                      />
                      {touched.phone && !phoneValid && (
                        <ErrText>Enter a valid phone number for the selected country.</ErrText>
                      )}
                    </Field>
                    <Field label='Email' required>
                      <input
                        className={
                          'cap-input cap-field-box-sm' +
                          (touched.email && !emailValid ? ' cap-field-box-sm--error' : '')
                        }
                        type='email'
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          resolvedEmailRef.current = ''; // real edit — allow a fresh check on next blur
                          setPrimaryEmailExists(false);
                          setAvailableMembers([]);
                          setPrimaryNameLocked(false);
                        }}
                        onBlur={handleEmailBlur}
                        placeholder='jane@email.com'
                      />
                      {touched.email && !emailValid && <ErrText>Enter a valid email address.</ErrText>}
                    </Field>
                    <Field label='Date of birth' required>
                      <DatePicker
                        selected={parseDateValue(dob)}
                        onChange={(date) => setDob(date ? formatDateValue(date) : '')}
                        dateFormat='MM/dd/yyyy'
                        placeholderText='MM/DD/YYYY'
                        customInput={
                          <input
                            className={
                              'cap-input cap-field-box-sm' +
                              (touched.dob && !dobValid ? ' cap-field-box-sm--error' : '')
                            }
                          />
                        }
                        minDate={parseDateValue('1900-01-01')}
                        maxDate={new Date(Date.now() - 86400000)}
                        onBlur={() => setTouched((prev) => ({ ...prev, dob: true }))}
                        showPopperArrow={false}
                      />
                      {touched.dob && !dobValid && <ErrText>Enter a valid date of birth.</ErrText>}
                    </Field>
                  </div>
                  <Field label='Residential address' required>
                    <AddressAutocomplete
                      value={address}
                      onChange={(val) => setAddress(val)}
                      onBlur={() => setTouched((prev) => ({ ...prev, address: true }))}
                      hasError={touched.address && !addrValid}
                      placeholder='Start typing your address…'
                    />
                    {touched.address && !addrValid && <ErrText>Please enter your residential address.</ErrText>}
                  </Field>

                  {showExistingAccountNotice && (
                    <div
                      style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(20, 20, 20, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000
                      }}
                      onClick={handleExistingAccountCancel}
                    >
                      <div
                        role='dialog'
                        aria-modal='true'
                        style={{
                          background: '#fff',
                          borderRadius: '10px',
                          padding: '28px',
                          maxWidth: '440px',
                          width: '90%',
                          boxShadow: '0 10px 40px rgba(0,0,0,0.25)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                          <span style={{ color: '#F5A623', flexShrink: 0, marginTop: '2px' }}>
                            <HelpIcon />
                          </span>
                          <div>
                            <p
                              style={{
                                margin: 0,
                                fontSize: '15px',
                                color: '#1B365D',
                                lineHeight: 1.5,
                                fontWeight: 500
                              }}
                            >
                              Welcome back! Would you like to proceed with this email ID and existing profile?
                            </p>
                            <p style={{ margin: '10px 0 0', fontSize: '14px', color: '#6b7280' }}>{email}</p>
                          </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                          <button
                            type='button'
                            onClick={handleExistingAccountCancel}
                            style={{
                              background: '#fff',
                              color: '#374151',
                              border: '1px solid #d1d5db',
                              borderRadius: '8px',
                              padding: '10px 20px',
                              fontWeight: 600,
                              fontSize: '13px',
                              letterSpacing: '0.04em',
                              textTransform: 'uppercase',
                              cursor: 'pointer'
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type='button'
                            onClick={handleExistingAccountContinue}
                            style={{
                              background: 'var(--cap-green)',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '8px',
                              padding: '10px 22px',
                              fontWeight: 600,
                              fontSize: '13px',
                              letterSpacing: '0.04em',
                              textTransform: 'uppercase',
                              cursor: 'pointer'
                            }}
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {availableMembers.length > 0 && (
                    <div
                      style={{
                        marginTop: '20px',
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '4px',
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#1B365D' }}>
                        Available Family Members
                      </h4>
                      <p style={{ margin: '0 0 15px 0', fontSize: '12px', color: '#666' }}>
                        Select members to automatically add them to your trip.
                      </p>
                      {availableMembers.map((m) => {
                        const isSelected = Object.values(familyUserIds).includes(m.userId);
                        return (
                          <label
                            key={m.userId}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginBottom: '8px',
                              cursor: 'pointer'
                            }}
                          >
                            <input
                              type='checkbox'
                              checked={isSelected}
                              onChange={(e) => handleSelectAvailableMember(m, e.target.checked)}
                              style={{ marginRight: '10px' }}
                            />
                            <span style={{ fontSize: '14px' }}>
                              {m.firstName} {m.lastName} {m.dateOfBirth ? `(DOB: ${m.dateOfBirth.split('T')[0]})` : ''}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  )}
                  {emailNew && (
                    <div className='cap-two-col'>
                      <Field label='Create password' required>
                        <input
                          className={
                            'cap-input cap-field-box-sm' +
                            (touched.password && password.length < 8 ? ' cap-field-box-sm--error' : '')
                          }
                          type='password'
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onBlur={() => setTouched((prev) => ({ ...prev, password: true }))}
                          placeholder='••••••••'
                        />
                        {touched.password && password.length < 8 && (
                          <ErrText>Password must be at least 8 characters.</ErrText>
                        )}
                      </Field>
                      <Field label='Confirm password' required>
                        <input
                          className={
                            'cap-input cap-field-box-sm' +
                            (touched.confirmPassword && password !== confirmPassword ? ' cap-field-box-sm--error' : '')
                          }
                          type='password'
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          onBlur={() => setTouched((prev) => ({ ...prev, confirmPassword: true }))}
                          placeholder='••••••••'
                        />
                        {touched.confirmPassword && password !== confirmPassword && (
                          <ErrText>Passwords do not match.</ErrText>
                        )}
                      </Field>
                    </div>
                  )}
                </div>

                {coverageType === 'family' && (
                  <div className='cap-card'>
                    <div className='cap-card__head-row'>
                      <SectionLabel>Family members ({familyCount})</SectionLabel>
                      <span className='cap-card__head-note'>Each gets their own app login</span>
                    </div>
                    {Array.from({ length: Math.max(1, familyCount) }, (_, i) => i).map((memberIndex) => {
                      const memberKey = 'fm' + memberIndex;
                      const hasDifferentAddress = familyAddr.hasOwnProperty(memberKey);
                      const isMinorMember = !!familyMinor[memberKey];
                      const memberPhone = getPhoneWidget(memberKey);
                      return (
                        <div key={memberIndex} className='cap-member'>
                          <div className='cap-member__header'>
                            <div className='cap-member__title'>Member {memberIndex + 1}</div>
                            <button
                              type='button'
                              className='cap-member__remove'
                              onClick={() => removeFamilyMember(memberIndex)}
                            >
                              Remove
                            </button>
                          </div>
                          <div className='cap-two-col cap-two-col--g14'>
                            <Field label='Full name' required>
                              <input
                                className={
                                  'cap-input cap-field-box-sm' +
                                  (touched[memberKey + '_name'] && !(familyNames[memberKey] || '').trim()
                                    ? ' cap-field-box-sm--error'
                                    : '')
                                }
                                type='text'
                                placeholder='Full name'
                                value={familyNames[memberKey] || ''}
                                onBlur={() => setTouched((prev) => ({ ...prev, [memberKey + '_name']: true }))}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setFamilyNames((prev) => ({ ...prev, [memberKey]: val }));
                                }}
                                disabled={!!familyUserIds[memberKey] || !!familyNameLocked[memberKey]}
                              />
                              {touched[memberKey + '_name'] && !(familyNames[memberKey] || '').trim() && (
                                <ErrText>Full name is required.</ErrText>
                              )}
                            </Field>
                            {!isMinorMember && (
                              <Field label='Email (app login)' required>
                                <input
                                  className={
                                    'cap-input cap-field-box-sm' +
                                    (touched[memberKey + '_email'] && !isValidEmail(familyEmails[memberKey] || '')
                                      ? ' cap-field-box-sm--error'
                                      : '')
                                  }
                                  type='email'
                                  placeholder='Email (app login)'
                                  value={familyEmails[memberKey] || ''}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setFamilyEmails((prev) => ({ ...prev, [memberKey]: val }));
                                    familyResolvedEmailRef.current[memberKey] = '';
                                    setFamilyNameLocked((prev) => ({ ...prev, [memberKey]: false }));
                                    if (familyEmailExists[memberKey]) {
                                      setFamilyEmailExists((prev) => ({
                                        ...prev,
                                        [memberKey]: false
                                      }));
                                    }
                                    if (familyUserIds[memberKey]) {
                                      const isFromAvailable = availableMembers.some(
                                        (m) => m.userId === familyUserIds[memberKey]
                                      );
                                      if (!isFromAvailable) {
                                        setFamilyUserIds((prev) => {
                                          const next = { ...prev };
                                          delete next[memberKey];
                                          return next;
                                        });
                                      }
                                    }
                                  }}
                                  onBlur={(e) => {
                                    setTouched((prev) => ({
                                      ...prev,
                                      [memberKey + '_email']: true
                                    }));
                                    handleFamilyEmailBlur(memberKey, e.target.value);
                                  }}
                                />
                                {touched[memberKey + '_email'] &&
                                  !isValidEmail(familyEmails[memberKey] || '') && (
                                    <ErrText>Valid email is required.</ErrText>
                                  )}
                              </Field>
                            )}
                            <Field label='Date of birth' required>
                              <DatePicker
                                selected={parseDateValue(familyDobs[memberKey] || '')}
                                onChange={(date) => {
                                  const val = date ? formatDateValue(date) : '';
                                  setFamilyDobs((prev) => ({ ...prev, [memberKey]: val }));
                                }}
                                dateFormat='MM/dd/yyyy'
                                placeholderText='MM/DD/YYYY'
                                customInput={
                                  <input
                                    className={
                                      'cap-input cap-field-box-sm' +
                                      (touched[memberKey + '_dob'] &&
                                      (ageFromDob(familyDobs[memberKey] || '') === null ||
                                        ageFromDob(familyDobs[memberKey] || '') < 0 ||
                                        ageFromDob(familyDobs[memberKey] || '') > 120)
                                        ? ' cap-field-box-sm--error'
                                        : '')
                                    }
                                  />
                                }
                                minDate={parseDateValue('1900-01-01')}
                                maxDate={new Date(Date.now() - 86400000)}
                                onBlur={() => {
                                  setTouched((prev) => ({ ...prev, [memberKey + '_dob']: true }));
                                }}
                                showPopperArrow={false}
                              />
                              {touched[memberKey + '_dob'] &&
                                (ageFromDob(familyDobs[memberKey] || '') === null ||
                                  ageFromDob(familyDobs[memberKey] || '') < 0 ||
                                  ageFromDob(familyDobs[memberKey] || '') > 120) && (
                                  <ErrText>Valid date of birth is required.</ErrText>
                                )}
                            </Field>
                            {!isMinorMember && (
                              <Field label='Phone number' required>
                                <PhoneInput
                                  country={memberPhone.country}
                                  value={memberPhone.value}
                                  onChange={memberPhone.onChange}
                                  inputClass={
                                    'cap-input cap-field-box-sm cap-field-box--phone' +
                                    (touched[memberKey + '_phone'] &&
                                    !validatePhoneForCountry(memberPhone.value, memberPhone.countryCode)
                                      ? ' cap-field-box-sm--error'
                                      : '')
                                  }
                                  containerClass='cap-phone-input cap-phone-input--sm'
                                  buttonClass='cap-phone-button cap-phone-button--sm'
                                  enableSearch
                                  disableSearchIcon
                                  disableCountryGuess={true}
                                  countryCodeEditable={false}
                                  placeholder='Enter phone number'
                                  onBlur={() =>
                                    setTouched((prev) => ({
                                      ...prev,
                                      [memberKey + '_phone']: true
                                    }))
                                  }
                                />
                                {touched[memberKey + '_phone'] &&
                                  !validatePhoneForCountry(memberPhone.value, memberPhone.countryCode) && (
                                    <ErrText>Enter a valid phone number for the selected country.</ErrText>
                                  )}
                              </Field>
                            )}
                          </div>
                          <label className='cap-checkbox-row'>
                            <input
                              type='checkbox'
                              checked={isMinorMember}
                              onChange={() => {
                                const becomingMinor = !isMinorMember;
                                setFamilyMinor((prev) => ({
                                  ...prev,
                                  [memberKey]: becomingMinor
                                }));
                                if (becomingMinor) {
                                  // Clear email and phone for this member since minors don't need them
                                  setFamilyEmails((prev) => {
                                    const updated = { ...prev };
                                    delete updated[memberKey];
                                    return updated;
                                  });
                                  setPhones((prev) => {
                                    const updated = { ...prev };
                                    delete updated[memberKey];
                                    return updated;
                                  });
                                  // Reset touched state so errors don't linger
                                  setTouched((prev) => {
                                    const updated = { ...prev };
                                    delete updated[memberKey + '_phone'];
                                    delete updated[memberKey + '_email'];
                                    return updated;
                                  });
                                }
                              }}
                              className='cap-checkbox'
                            />
                            Minor (no email or phone number)
                          </label>
                          <label className='cap-checkbox-row'>
                            <input
                              type='checkbox'
                              checked={!hasDifferentAddress}
                              onChange={() => {
                                setFamilyAddr((prev) => {
                                  const updated = { ...prev };
                                  if (hasDifferentAddress) {
                                    // Switching back to "same as primary" – clear the stored address
                                    delete updated[memberKey];
                                  } else {
                                    // Switching to "different" – initialise with empty string
                                    updated[memberKey] = '';
                                  }
                                  return updated;
                                });
                              }}
                              className='cap-checkbox'
                            />
                            Same address as primary subscriber
                          </label>
                          {hasDifferentAddress && (
                            <AddressAutocomplete
                              value={familyAddr[memberKey] || ''}
                              onChange={(val) => setFamilyAddr((prev) => ({ ...prev, [memberKey]: val }))}
                              placeholder="Member's residential address"
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {showFamilyAccountNotice && (
                  <div
                    style={{
                      position: 'fixed',
                      inset: 0,
                      background: 'rgba(20, 20, 20, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10000
                    }}
                    onClick={() => handleFamilyAccountCancel(showFamilyAccountNotice)}
                  >
                    <div
                      role='dialog'
                      aria-modal='true'
                      style={{
                        background: '#fff',
                        borderRadius: '10px',
                        padding: '28px',
                        maxWidth: '440px',
                        width: '90%',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.25)'
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                        <span style={{ color: '#F5A623', flexShrink: 0, marginTop: '2px' }}>
                          <HelpIcon />
                        </span>
                        <div>
                          <p style={{ margin: 0, fontSize: '15px', color: '#1B365D', lineHeight: 1.5, fontWeight: 500 }}>
                            Welcome back! Would you like to proceed with this email ID and existing profile?
                          </p>
                          <p style={{ margin: '10px 0 0', fontSize: '14px', color: '#6b7280' }}>
                            {familyEmails[showFamilyAccountNotice]}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                        <button
                          type='button'
                          onClick={() => handleFamilyAccountCancel(showFamilyAccountNotice)}
                          style={{
                            background: '#fff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            fontWeight: 600,
                            fontSize: '13px',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            cursor: 'pointer'
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type='button'
                          onClick={() => handleFamilyAccountContinue(showFamilyAccountNotice)}
                          style={{
                            background: 'var(--cap-green)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px 22px',
                            fontWeight: 600,
                            fontSize: '13px',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            cursor: 'pointer'
                          }}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className='cap-card'>
                  <div className='cap-card__head-row'>
                    <SectionLabel>Payment</SectionLabel>
                    <span className='cap-pay-secured'>
                      <LockIcon />
                      Secured by Stripe
                    </span>
                  </div>

                  {/* Stripe Payment Element (Card, Apple Pay, Google Pay) */}
                  <div className='cap-stripe-container'>
                    {!clientSecret ? (
                      <div className='cap-loading-text'>
                        <SpinnerIcon size={16} /> Loading secure payment...
                      </div>
                    ) : (
                      <Elements stripe={stripePromise} options={{ clientSecret, appearance: { theme: 'stripe' } }}>
                        <StripePaymentForm
                          isProcessing={payProcessing}
                          onPaymentSuccess={handleStripePaymentSuccess}
                          onPaymentError={handleStripePaymentError}
                          setPayProcessing={setPayProcessing}
                        />
                      </Elements>
                    )}
                  </div>

                  {/* <div
                    className='cap-pay-or'
                    style={{
                      textAlign: 'center',
                      margin: '25px 0',
                      color: '#6B7280',
                      fontSize: '13px',
                      fontWeight: 600
                    }}
                  >
                    — OR PAY WITH PAYPAL —
                  </div> */}

                  {/* PayPal */}
                  {/* <div className='cap-paypal-wrap'>
                    <PayPalScriptProvider
                      options={{
                        'client-id': config.clientTokenPaypal,
                        currency: 'USD',
                        'disable-funding': 'paylater'
                      }}
                    >
                      <PayPalButtons
                        style={{ layout: 'horizontal', tagline: false }}
                        createOrder={function() {
                          if (!detailsValid) {
                            setPayError('Please complete all required traveller details before paying.');
                            return Promise.reject(new Error('Details incomplete'));
                          }
                          setPayError('');
                          const orderPayload = buildOrderPayload(null);
                          console.log('[CAP] Order payload (paypal):', JSON.stringify(orderPayload, null, 2));
                          return props.createOrderPaypal(orderPayload);
                        }}
                        onApprove={async (data) => {
                          setPayProcessing(true);
                          setPayError('');
                          try {
                            const res = await props.captureOrderPaypal(data.orderID, buildOrderPayload(null));
                            const respData = res && res.data ? res.data : res;
                            if (respData && respData.status === 200) {
                              goToStep(4);
                            } else {
                              setPayError('PayPal payment could not be confirmed. Please try again.');
                            }
                          } catch (err) {
                            setPayError('PayPal error. Please try again.');
                          }
                          setPayProcessing(false);
                        }}
                        onError={() => setPayError('PayPal encountered an error. Please try again.')}
                      />
                    </PayPalScriptProvider>
                  </div> */}

                  {payError && (
                    <div className='cap-pay-error'>
                      <span className='cap-err'>{payError}</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}

            {/* STEP 4 — confirmation */}
            {step === 4 && (
              <QuoteConfirmation
                email={email}
                planName={planName}
                summaryCoverage={summaryCoverage}
                destSummary={destSummary}
                travelersCount={travelersCount}
                grand={grand}
                canShowPricing={canShowPricing}
                money0={money0}
                onReset={props.onResetFlow}
              />
            )}
          </div>

          {showSummary && (
            <aside className='cap-sidebar'>
              <div className='cap-sidebar__mobile-toggle' onClick={() => setMobileSummaryOpen(!mobileSummaryOpen)}>
                <SectionLabel>Order summary</SectionLabel>
                <div className='cap-sidebar__toggle-right'>
                  <span className='cap-sidebar__toggle-total'>{canShowPricing ? money(grand) : '—'}</span>
                  <span className='cap-sidebar__toggle-icon'>{mobileSummaryOpen ? '▲' : '▼'}</span>
                </div>
              </div>
              <div className={'cap-sidebar__content' + (mobileSummaryOpen ? ' cap-sidebar__content--open' : '')}>
                <div className='cap-sidebar__plan'>
                  <span
                    className={
                      'cap-sidebar__plan-icon' + (chosenPlan === 'medical' ? ' cap-sidebar__plan-icon--medical' : '')
                    }
                  >
                    <SidebarPlanIcon plan={chosenPlan} />
                  </span>
                  <div className='cap-sidebar__plan-titles'>
                    <span className='cap-sidebar__plan-name'>{planName}</span>
                    <span className='cap-sidebar__plan-desc'>{summaryPlanSub}</span>
                  </div>
                </div>

                <div className='cap-sidebar__details'>
                  <SumRow label='Coverage' value={summaryCoverage} small />
                  <SumRow
                    label='Destinations'
                    value={formattedDestinations.length ? formattedDestinations.join(', ') : '—'}
                    small
                  />
                  <div className='cap-sidebar__detail-row'>
                    <div className='cap-sidebar__detail-label'>
                      Travelers
                      {coverageType === 'individual' && (
                        <button
                          type='button'
                          className='cap-sidebar__detail-link'
                          style={{ marginLeft: '6px' }}
                          onClick={() => {
                            setCoverageType('family');
                            setFamilyCount(1);
                          }}
                        >
                          (Add Member)
                        </button>
                      )}
                    </div>
                    <div className='cap-sidebar__detail-value-wrap'>
                      {coverageType === 'family' ? (
                        <div className='cap-counter cap-counter--sm'>
                          <button
                            type='button'
                            className='cap-counter-btn cap-counter-btn--sm'
                            onClick={() => {
                              if (familyCount <= 1) {
                                setFamilyCount(0);
                                setCoverageType('individual');
                              } else {
                                setFamilyCount(familyCount - 1);
                              }
                            }}
                          >
                            −
                          </button>
                          <span className='cap-counter__value'>{travelersCount}</span>
                          <button
                            type='button'
                            className='cap-counter-btn cap-counter-btn--sm'
                            onClick={() => setFamilyCount(Math.min(familyCount + 1, 9))}
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <span className='cap-sidebar__detail-value'>{travelersCount}</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* {perDaySummary && <div className='cap-sidebar__perday'>{perDaySummary}</div>} */}

                <div className='cap-divider' />

                <div className='cap-sidebar__rows'>
                  <SumRow label='Subtotal' value={money(subtotal)} />
                  {domesticAddon && domAddOn > 0 && <SumRow label='CAP Domestic addon' value={money(domAddOn)} />}
                  {hasCouponDiscount && (
                    <SumRow
                      label={`Promo (${couponCodeUsed}${couponDiscountVal ? ` ${couponDiscountVal}` : ''})`}
                      value={`-${money(discount)}`}
                    />
                  )}
                  <div className='cap-sidebar__total'>
                    <span className='cap-sidebar__total-label'>Total</span>
                    <span className='cap-sidebar__total-value'>{canShowPricing ? money(grand) : '—'}</span>
                  </div>
                </div>

                {step === 3 && (
                  <div className='cap-promo'>
                    <div className='cap-promo__row'>
                      <input
                        className='cap-input cap-promo__input'
                        type='text'
                        value={promoInput}
                        onChange={(e) => setPromoInput(e.target.value)}
                        placeholder='PROMO CODE'
                        disabled={isApplyingPromo}
                      />
                      <button
                        type='button'
                        onClick={applyPromo}
                        className='cap-promo__apply'
                        disabled={
                          !promoInput.trim() || isApplyingPromo || promoInput.trim().toUpperCase() === appliedCouponCode
                        }
                      >
                        {isApplyingPromo ? <SpinnerIcon size={14} /> : 'Apply'}
                      </button>
                    </div>
                    {(promoApplied || promoError || hasCouponDiscount) && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          gap: '12px'
                        }}
                      >
                        <span
                          className={
                            'cap-promo__msg ' +
                            (promoApplied || hasCouponDiscount ? 'cap-promo__msg--ok' : 'cap-promo__msg--err')
                          }
                          style={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}
                        >
                          {isApplyingPromo
                            ? 'Validating code...'
                            : hasCouponDiscount
                            ? `Code applied — ${couponCodeUsed}${couponDiscountVal ? ` (${couponDiscountVal})` : ''}`
                            : "That code isn't valid."}
                        </span>
                        {(promoApplied || hasCouponDiscount) && (
                          <button
                            type='button'
                            onClick={() => {
                              setPromoInput('');
                              setAppliedCouponCode('');
                              setPromoApplied(null);
                              setPromoError(false);
                              setIsApplyingPromo(false);
                            }}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: 'var(--cap-danger)',
                              fontSize: '12px',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              padding: '2px 0 0 0',
                              flexShrink: 0
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}

                <div className='cap-sidebar__footer'>
                  <CheckIcon size={14} color='#56B947' />
                  $0 out of pocket · No claims · Cancel anytime
                </div>
              </div>
            </aside>
          )}

          {step === 3 && (
            <div className='cap-checkout-footer'>
              {isMinor && (
                <label className='cap-parental'>
                  <input
                    type='checkbox'
                    checked={parental}
                    onChange={() => setParental(!parental)}
                    className='cap-checkbox--lg'
                  />
                  <span className='cap-parental__text'>
                    The primary traveler is under 18. I confirm a parent or legal guardian is present and consents to
                    this purchase. <Req />
                  </span>
                </label>
              )}
              <label className='cap-consent'>
                <input
                  type='checkbox'
                  checked={agreeTerms}
                  onChange={() => setAgreeTerms(!agreeTerms)}
                  className='cap-checkbox--lg'
                />
                <span className='cap-consent__text'>
                  I agree to CAP's{' '}
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href={
                      plan === 'medical'
                        ? '/CAP_Medical_Assist_v2.pdf'
                        : plan === 'complete'
                        ? '/CAP_Total_Assist_v2.pdf'
                        : 'https://www.captravelassistance.com/rules-and-regulations/'
                    }
                    className='cap-link'
                  >
                    Rules &amp; Regulations
                  </a>{' '}
                  and{' '}
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://www.captravelassistance.com/privacy-policy/'
                    className='cap-link'
                  >
                    Privacy Policy
                  </a>
                  . <Req />
                </span>
              </label>

              {/* Place Order button (for Stripe payments) */}
              <button
                type='button'
                onClick={handleInitiatePayment}
                disabled={payProcessing || !clientSecret}
                className='cap-btn-primary cap-btn-primary--lg'
              >
                {payProcessing ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <SpinnerIcon size={18} /> Processing…
                  </span>
                ) : (
                  `Pay ${canShowPricing ? money0(grand) : '—'} · Place order`
                )}
              </button>
              <p className='cap-cancel-note'>Cancel anytime before your coverage start date.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    allUsStates: state.b2c.allUsStates,
    ...state.b2c,
    ...state.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...adminActions, ...b2cActions, ...productActions }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Quote));
